<template>
  <section>
    <b-card class="mb-1 sticky-top" style="height: 58px; font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body>
      <b-row>
        <b-col xl="9" md="9" sm="9">
          <b-row class="first-cls d-flex align-items-center justify-content-start">
            <span class="bg-primary round text-white ml-2" style="width: 80px; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">기간</span>
            <flat-pickr
              class="periodpickr form-control border-2"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
              placeholder="YYYY-MM ~ YYYY-MM"
              :config="configs.monthSelect" 
              :value="form.monthSelect"
              @on-open="datePickerOnOpen"
              @on-change="datePickerOnChange"
              @on-close="datepickerCloseHandler"
            />
            <span class="bg-primary round text-white ml-5" style="width: 80px; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">조건</span>
            <v-select
              class="first-class"
              label="대분류(전체)"       
              :items="firstClassList"
              :menu-props="{ contentClass: 'istselectitemlist',
                             closeOnContentClick: false,
              }"
              item-text = 'title'
              item-value = 'id'
              multiple
              :clearable="true"
              hide-details
              outlined
              v-model="selectedFirstClasses"
              style="height: 32px; margin-left: 5px;"
              append-icon="mdi-chevron-down"
              @change="majorChange"
            >
              <template v-slot:prepend-item>
                <v-checkbox
                  v-if="firstClassList.length > 1"
                  class="insselectallcond"
                  v-model=isSelectAll_cond
                  :color="isSelectAll_cond ? '#1817E7' : 'undefined'"
                  :indeterminate="isSelectSome_cond && !isSelectAll_cond"
                  :ripple="false"
                  hide-details
                  @click="selectAllCond"
                >
                  <template v-slot:label>
                    <span style="color: #1817E7; font-size: 12px; font-weight: 600; padding: 0px; margin: 2px 0px 0px 5px;">(모두 선택)</span>
                  </template>
                </v-checkbox>
                <v-divider v-if="firstClassList.length > 1" class="insdivider" />
              </template>
              <template v-slot:selection="{item, index}">
                <v-chip v-if="index < maxDisplay" style="height: 20px; font-size: 10px; font-weight: 500;" x-small close @click:close="removeSelItem(selectedFirstClasses, index)">{{ item.title }}</v-chip>
                <span
                  v-if="index === maxDisplay"
                  class="caption ml-1"
                  style="color:#5e5873; font-family: NanumBarunGothic !important; font-weight: 600; margin-top: 3px;"
                  >(+{{ selectedFirstClasses.length - maxDisplay }} 대분류)
                </span>
              </template>
            </v-select> 
            <vue-select
              class="middle-class mr-5"
              label="title"            
              :options="middleClassList"
              :clearable="true"
              v-model="selectedMiddleClass"
              placeholder="중분류(전체)"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
              @input="middleChange"
            >
              <template v-slot:no-options >
                <em style="opacity: 0.5; font-size: 12px;">대분류 항목을 선택하세요.</em>
              </template>
            </vue-select>
            <v-divider
              thickness="10"
              class="border-opacity-100"
              style="border-width: 1.2px; margin-top: 3px; margin-bottom: 1px; border-color: #d8d6de;"
              vertical
            />
            <b-button class="ml-5" id="analysis" style="height: 28px; width: 80px; padding: 0.5rem 0.85rem; margin-left: 5px;" @click="runAnalysis">
              분석하기
            </b-button>
          </b-row>
        </b-col>
        <b-col xl="1" md="1" sm="1">
        </b-col>
        <b-col xl="2" md="2" sm="2">
          <b-row class="d-flex align-items-center justify-content-end">
            <b-button id="exp_pdf" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToPDF">
              <div v-if="isPdfExporting" class="spinner-border spinner-border-sm"></div>
              <div v-else>
                <i class="fa-regular fa-file-pdf fa-lg"/>
              </div>
            </b-button>
            <b-tooltip target="exp_pdf" triggers="hover"> Export to PDF </b-tooltip>
            <b-button id="exp_xls" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToExcel">
              <div v-if="isXlsExporting" class="spinner-border spinner-border-sm"></div>
              <div v-else>
                <i class="fa-regular fa-file-excel fa-lg"/>
              </div>
            </b-button>    
            <b-tooltip target="exp_xls" triggers="hover"> Export to Excel </b-tooltip>   
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <b-card ref="istPrintArea1" class="mb-1" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row>
        <b-col cols="7" style="text-align: left; color:whitesmoke; font-size: 14px; margin-left: 1.0rem; margin-top: 1.0rem; padding: 5px; background-color:lightslategray; border-radius: 5px;">
          <span>
            💡 카테고리 관련 소비자의 관심사를 한눈에 살펴볼 수 있어, 타깃 구체화/제품 포지셔닝 개발에 활용할 수 있습니다. </br>
          </span>
          <span style="margin-left: 22px;">
            많은 탐색이 일어나는 키워드를 통해, 소비자의 니즈를 해결해 주는 제품/서비스와 콘텐츠를 기획할 수 있습니다.
          </span>
        </b-col>
        <b-col cols="7" style="text-align: left; color:whitesmoke; font-size: 14px; margin-left: 1.0rem; margin-top: 1.0rem; padding: 5px; background-color:lightslategray; border-radius: 5px;">
          <span>
            ⚠️ INSIGHT에서는 하나의 키워드에 둘 이상의 속성이 포함될 경우, 각 속성에 키워드의 검색량이 중복 카운팅 됩니다. </br>
          </span>
          <span style="margin-left: 22px;">
            예: 투썸크리스마스케이크예약 100건: 투썸플레이스(브랜드) 100건, 크리스마스(용도/목적) 100건, 예약(가입/구매) 100건
          </span>
        </b-col>
      </b-row>
      <b-row style="margin-top: 10px;">
        <b-col xl="9" md="9" sm="9">
          <b-row>
            <b-col style="text-align: center; margin-bottom: 1rem;">
              <h1>소비자 탐색 오버뷰</h1>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="text-align: left; color: #ea5455;">👍 카테고리 탐색, 속성 탐색, 구매 및 관리, TOTAL 각 영역을 클릭하면 하단 그래프와 우측 키워드가 변경됩니다.</b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col style="text-align: left; color: #28c76f;">✌ 하단 그래프의 브랜드 그래프를 선택하시면 우측 키워드가 변경됩니다.</b-col>
          </b-row>
          <hr style="margin-bottom: 0.4%; border-color: #6B6B6B; border-width: 2px;">
          <b-row class="row-background-title d-flex align-item-center justify-content-center">
            <b-col>
              <b-button id="tab_button4" class="tab_button4" autofocus @click="clickCDJBtn('total')">
                TOTAL 
                <span style="color: #7367f0;">
                  <b>{{ Math.round(this.total_search_freq_upper).toLocaleString() }}</b>
                </span>
              </b-button>                
            </b-col>
          </b-row>
          <hr style="margin-top: 0.4%; margin-bottom: 0.4%; border-color: #6B6B6B; border-width: 2px;">
          <b-row class="row-background d-flex align-item-center justify-content-center">
            <b-col>
                <b-button id="tab_button1" class="tab_button1" @click="clickCDJBtn('카테고리 탐색')">
                  카테고리 탐색
                  <br/>
                  <div style="color: #1951DC; margin-top: 5px;">
                    <b>{{ Math.round(this.general_search_freq_upper).toLocaleString() }}</b>
                  </div>
                </b-button>
                <b-button id="tab_button2" class="tab_button2" @click="clickCDJBtn('속성 탐색')">
                  속성 탐색 
                  <br/>
                  <div style="color: #1951DC; margin-top: 5px;">
                    <b>{{ Math.round(this.attribute_search_freq_upper).toLocaleString() }}</b>
                  </div>
                </b-button>
                <b-button id="tab_button3" class="tab_button3" @click="clickCDJBtn('구매 및 관리')">
                  구매 및 관리
                  <br/>
                  <div style="color: #1951DC; margin-top: 5px;">
                    <b>{{ Math.round(this.buy_manage_freq_upper).toLocaleString() }}</b>
                  </div>
                </b-button>
            </b-col>
          </b-row>
          <hr style="margin-top: 0.4%; border-color: #6B6B6B; border-width: 2px;">
          <b-row style="margin-top: 2%; margin-bottom: -3%;">
            <b-col id="insightDonutCol" xl="6" md="6" sm="6" style="position: relative;">
              <div id="loadingDonut" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 40%; visibility: visible;">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>분석중...</strong>
              </div>
              <div id="donutChart" style="visibility: hidden;">
                <insight-chart-donut
                :donutChartData="donutChartData"
                :totalFreq="totalFreq"
                :isChartInit="donutChartInit"
                />
              </div>
            </b-col>
            <b-col id="insightBarCol" xl="6" md="6" sm="6" style="position: relative; min-height: 500px;">
              <div id="loadingBar" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 40%; visibility: visible;">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>분석중...</strong>
              </div>
              <div class="graphic-container" id="barChart" style="visibility: hidden;">
                <insight-chart-bar
                  :height="height"
                  :barChartData="barChartData"
                  :barChartFreq="barChartFreq"
                  :barChartCategory="barChartCategory"
                  :totalFreq="totalFreq"
                />
              </div>
            </b-col>
          </b-row>
          <hr style="margin-top: 0.4%; border-color: #6B6B6B; border-width: 2px;">
          <div v-if="this.donutChartInit" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-top: 5px; margin-bottom: 20px;">          
            <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
              <div style="margin-bottom: 4px;">
                • 이 카테고리의 소비자 탐색은 <b>카테고리 탐색 - {{ Math.round(this.general_search_freq_upper).toLocaleString() }}</b>건, <b>속성 탐색 - {{ Math.round(this.attribute_search_freq_upper).toLocaleString() }}</b>건, <b>구매 및 관리 - {{ Math.round(this.buy_manage_freq_upper).toLocaleString() }}</b>건이 검색 되었습니다. 
              </div>        
              <div style="margin-bottom: 4px;">
                • <b>{{ this.selectedCDJ.toUpperCase() }}</b> 영역에서 NONBRANDED 검색량은 <b>{{ (this.donutChartData[1] / this.totalFreq * 100.0).toFixed(1) }}%</b> 를 차지하였고, BRANDED 검색량은 <b>{{ (this.donutChartData[0] / this.totalFreq * 100.0).toFixed(1) }}%</b>를 차지하였습니다.
              </div>
              <div v-if="this.barChartCategory.length == 1" style="margin-bottom: 4px;">
                • <b>{{ this.selectedCDJ.toUpperCase() }}</b> 영역에서 가장 많이 검색된 브랜드는 🥇<b>{{ this.barChartCategory[0] }}</b> 입니다. 
              </div>
              <div v-else-if="this.barChartCategory.length == 2" style="margin-bottom: 4px;">
                • <b>{{ this.selectedCDJ.toUpperCase() }}</b> 영역에서 가장 많이 검색된 브랜드는 🥇<b>{{ this.barChartCategory[0] }}</b>였으며, 그 뒤를 🥈<b>{{ this.barChartCategory[1] }}</b> 가 쫓고 있습니다. 
              </div>
              <div v-else-if="this.barChartCategory.length > 2" style="margin-bottom: 4px;">
                • <b>{{ this.selectedCDJ.toUpperCase() }}</b> 영역에서 가장 많이 검색된 브랜드는 🥇<b>{{ this.barChartCategory[0] }}</b>였으며, 그 뒤를 🥈<b>{{ this.barChartCategory[1] }}</b>, 🥉<b>{{ this.barChartCategory[2] }}</b> 가 쫓고 있습니다. 
              </div>
            </div>
          </div>
        </b-col>
        <b-col xl="3" md="3" sm="3">
          <b-row>
            <b-col style="text-align: center; font-size: 2rem;">
              <h1>검색량<br/>상위 키워드 50</h1>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="text-align: center; color: #6B6B6B; margin-bottom: 0.5rem;">
              {{ this.mapUpperHistory.toUpperCase() }}
            </b-col>
          </b-row>
          <b-row>
            <b-col style="padding-left: 0.25rem; ">
              <b-table
                class="table1 position-relative"
                ref="refInsightTable1"
                :items="fetchGroups1"
                :fields="tableColumns1"
                :busy="isBusy1"
                :sort-desc.sync="sortDesc1" 
                :sort-by.sync="sortBy1"
                :sort-direction='sortDirection1'
                responsive
                show-empty
                no-border-collapse
                outlined
                head-variant="light"
                hover
                table-class="table-font-size"
                empty-text="해당하는 키워드가 없습니다."
                sticky-header="true"
                style="max-height: 42.8rem;"
              >
                <template #head()="{ label, field: { key, sortable } }">
                  {{ label }}
                  <template v-if="sortable">
                    <b-img v-if="sortBy1 !== key" src="/caretupdown.png" style="width: 10px; margin-top: -2px;"></b-img>
                    <b-img v-else-if="sortDesc1" src="/caretup.png" style="width: 9px;"></b-img>
                    <b-img v-else src="/caretdown.png" style="width: 9px;"></b-img>
                  </template>
                </template>
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>분석중...</strong>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <!-- 스택차트 영역 -->
    <b-card ref="istPrintArea2" class="mb-1" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row>
        <b-col xl="8" md="8" sm="8">
          <b-row style="margin-top: 1rem;">
            <b-col xl="3" md="3" sm="3">
              <vue-select
                class="select-brand"
                label="title"            
                :options="brandList"
                :clearable="true"
                v-model="selectedBrand"
                placeholder="브랜드"
                style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
              >
              </vue-select>
            </b-col>
            <b-col style="text-align: center; font-size: 2rem; margin-bottom: 0.5rem;">
              <h1>소비자 탐색 인사이트</h1>
            </b-col>
            <b-col xl="3" md="3" sm="3">
              <div style="position: absolute; margin-top: 0.5rem; margin-left: 14rem;">
                <b-button id="compare1" style="height: auto; width: 3.5rem; padding: 0.3rem 0.4rem; margin-right: 5px;" @click="compareInsight">                  
                  <div style="margin-left: -0.1rem;">
                    <!-- <i class="fa-solid fa-arrows-left-right-to-line"></i> -->
                    비교
                  </div>
                </b-button>
                <b-tooltip target="compare1" triggers="hover"> 비교하기 </b-tooltip>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="text-align: left; color: #ea5455; margin-bottom: 0.5rem;">📢 표의 열 또는 그래프의 칸을 클릭하시면 자세한 내용을 우측과 아래에서 볼 수 있습니다.</b-col>
          </b-row>
          <b-row>
            <b-col id="insightCDJCol">
              <table id="cdjTable" class="cdjTable" v-if="this.selectedDisplayValue.id == 1">
                <tr id="cdjTable_1Tr" class="cdjTable_1Tr">
                  <th id="cdjTable_1Tr_4Th" class="cdjTable_1Tr_4Th" colspan="10" @click="loadInsightDataBottomTable('total', '', 'cdjTable_1Tr_4Th')" style="border-bottom-width: 2px;">
                    TOTAL 
                    <span style="color: #7367f0;">
                      <b>{{ Math.round(this.total_search_freq).toLocaleString() }}</b>
                    </span>
                  </th>
                </tr>
                <tr id="cdjTable_1Tr" class="cdjTable_1Tr">
                  <th id="cdjTable_1Tr_1Th" class="cdjTable_1Tr_1Th" colspan="3" @click="loadInsightDataBottomTable('cdj', '카테고리 탐색', 'cdjTable_1Tr_1Th')" style="border-right-width: 2px;">
                    카테고리 탐색
                    <br/>
                    <div style="color: #1951DC; margin-top: -3px;">
                      <small><b>{{ Math.round(this.general_search_freq).toLocaleString() }} ({{ this.general_search_rate }})</b></small>
                    </div>
                  </th>
                  <th id="cdjTable_1Tr_2Th" class="cdjTable_1Tr_2Th" colspan="5" @click="loadInsightDataBottomTable('cdj', '속성 탐색', 'cdjTable_1Tr_2Th')" style="border-right-width: 2px;">
                    속성 탐색
                    <br/>
                    <div style="color: #1951DC; margin-top: -3px;">
                      <small><b>{{ Math.round(this.attribute_search_freq).toLocaleString() }} ({{ this.attribute_search_rate }})</b></small>
                    </div>
                  </th>
                  <th id="cdjTable_1Tr_3Th" class="cdjTable_1Tr_3Th" colspan="2" @click="loadInsightDataBottomTable('cdj', '구매 및 관리', 'cdjTable_1Tr_3Th')" style="border-right-width: 2px;">
                    구매 및 관리
                    <br/>
                    <div style="color: #1951DC; margin-top: -3px;">
                      <small><b>{{ Math.round(this.buy_manage_freq).toLocaleString() }} ({{ this.buy_manage_rate }})</b></small>
                    </div>
                  </th>
                </tr>
                <tr id="cdjTable_2Tr" class="cdjTable_2Tr">
                  <td id="cdjTable_2Tr_1Td" class="cdjTable_2Tr_1Td" @click="loadInsightDataBottomTable('cdjDetails', general_search_detail_1_nm, 'cdjTable_2Tr_1Td')">
                    {{ this.general_search_detail_1_nm }}
                  </td>
                  <td id="cdjTable_2Tr_2Td" class="cdjTable_2Tr_2Td" @click="loadInsightDataBottomTable('cdjDetails', general_search_detail_2_nm, 'cdjTable_2Tr_2Td')">
                    {{ this.general_search_detail_2_nm }}
                  </td>
                  <td id="cdjTable_2Tr_3Td" class="cdjTable_2Tr_3Td" @click="loadInsightDataBottomTable('cdjDetails', general_search_detail_3_nm, 'cdjTable_2Tr_3Td')" style="border-right-width: 2px;">
                    {{ this.general_search_detail_3_nm }}
                  </td>
                  <td id="cdjTable_2Tr_4Td" class="cdjTable_2Tr_4Td" @click="loadInsightDataBottomTable('cdjDetails', attribute_search_detail_1_nm, 'cdjTable_2Tr_4Td')">
                    {{ this.attribute_search_detail_1_nm }}
                  </td>
                  <td id="cdjTable_2Tr_5Td" class="cdjTable_2Tr_5Td" @click="loadInsightDataBottomTable('cdjDetails', attribute_search_detail_2_nm, 'cdjTable_2Tr_5Td')">
                    {{ this.attribute_search_detail_2_nm }}
                  </td>
                  <td id="cdjTable_2Tr_6Td" class="cdjTable_2Tr_6Td" @click="loadInsightDataBottomTable('cdjDetails', attribute_search_detail_3_nm, 'cdjTable_2Tr_6Td')">
                    {{ this.attribute_search_detail_3_nm }}
                  </td>
                  <td id="cdjTable_2Tr_7Td" class="cdjTable_2Tr_7Td" @click="loadInsightDataBottomTable('cdjDetails', attribute_search_detail_4_nm, 'cdjTable_2Tr_7Td')">
                    {{ this.attribute_search_detail_4_nm }}
                  </td>
                  <td id="cdjTable_2Tr_8Td" class="cdjTable_2Tr_8Td" @click="loadInsightDataBottomTableETC('cdjDetails', [attribute_search_detail_1_nm, attribute_search_detail_2_nm, attribute_search_detail_3_nm, attribute_search_detail_4_nm], '속성 탐색', 'cdjTable_2Tr_8Td')" style="border-right-width: 2px;">
                    {{ this.attribute_search_detail_5_nm }}
                  </td>
                  <td id="cdjTable_2Tr_9Td" class="cdjTable_2Tr_9Td" @click="loadInsightDataBottomTable('cdjDetails', buy_manage_detail_1_nm, 'cdjTable_2Tr_9Td')">
                    {{ this.buy_manage_detail_1_nm }}
                  </td>
                  <td id="cdjTable_2Tr_10Td" class="cdjTable_2Tr_10Td" @click="loadInsightDataBottomTable('cdjDetails', buy_manage_detail_2_nm, 'cdjTable_2Tr_10Td')" style="border-right-width: 2px;">
                    {{ this.buy_manage_detail_2_nm }}
                  </td>
                </tr>
                <tr id="cdjTable_3Tr" class="cdjTable_3Tr">
                  <td id="cdjTable_3Tr_1Td" class="cdjTable_3Tr_1Td" @click="loadInsightDataBottomTable('cdjDetails', general_search_detail_1_nm, 'cdjTable_3Tr_1Td')">
                    {{ this.general_search_detail_1_rate }}
                  </td>
                  <b-tooltip target="cdjTable_3Tr_1Td" triggers="hover"> {{ Math.round(this.general_search_detail_1_freq).toLocaleString() }} </b-tooltip>
                  <td id="cdjTable_3Tr_2Td" class="cdjTable_3Tr_2Td" @click="loadInsightDataBottomTable('cdjDetails', general_search_detail_2_nm, 'cdjTable_3Tr_2Td')">
                    {{ this.general_search_detail_2_rate }}
                  </td>
                  <b-tooltip target="cdjTable_3Tr_2Td" triggers="hover"> {{ Math.round(this.general_search_detail_2_freq).toLocaleString() }} </b-tooltip>
                  <td id="cdjTable_3Tr_3Td" class="cdjTable_3Tr_3Td" @click="loadInsightDataBottomTable('cdjDetails', general_search_detail_3_nm, 'cdjTable_3Tr_3Td')" style="border-right-width: 2px;">
                    {{ this.general_search_detail_3_rate }}
                  </td>
                  <b-tooltip target="cdjTable_3Tr_3Td" triggers="hover"> {{ Math.round(this.general_search_detail_3_freq).toLocaleString() }} </b-tooltip>
                  <td id="cdjTable_3Tr_4Td" class="cdjTable_3Tr_4Td" @click="loadInsightDataBottomTable('cdjDetails', attribute_search_detail_1_nm, 'cdjTable_3Tr_4Td')">
                    {{ this.attribute_search_detail_1_rate }}
                  </td>
                  <b-tooltip target="cdjTable_3Tr_4Td" triggers="hover"> {{ Math.round(this.attribute_search_detail_1_freq).toLocaleString() }} </b-tooltip>
                  <td id="cdjTable_3Tr_5Td" class="cdjTable_3Tr_5Td" @click="loadInsightDataBottomTable('cdjDetails', attribute_search_detail_2_nm, 'cdjTable_3Tr_5Td')">
                    {{ this.attribute_search_detail_2_rate }}
                  </td>
                  <b-tooltip target="cdjTable_3Tr_5Td" triggers="hover"> {{ Math.round(this.attribute_search_detail_2_freq).toLocaleString() }} </b-tooltip>
                  <td id="cdjTable_3Tr_6Td" class="cdjTable_3Tr_6Td" @click="loadInsightDataBottomTable('cdjDetails', attribute_search_detail_3_nm, 'cdjTable_3Tr_6Td')">
                    {{ this.attribute_search_detail_3_rate }}
                  </td>
                  <b-tooltip target="cdjTable_3Tr_6Td" triggers="hover"> {{ Math.round(this.attribute_search_detail_3_freq).toLocaleString() }} </b-tooltip>
                  <td id="cdjTable_3Tr_7Td" class="cdjTable_3Tr_7Td" @click="loadInsightDataBottomTable('cdjDetails', attribute_search_detail_4_nm, 'cdjTable_3Tr_7Td')">
                    {{ this.attribute_search_detail_4_rate }}
                  </td>
                  <b-tooltip target="cdjTable_3Tr_7Td" triggers="hover"> {{ Math.round(this.attribute_search_detail_4_freq).toLocaleString() }} </b-tooltip>
                  <td id="cdjTable_3Tr_8Td" class="cdjTable_3Tr_8Td" @click="loadInsightDataBottomTableETC('cdjDetails', [attribute_search_detail_1_nm, attribute_search_detail_2_nm, attribute_search_detail_3_nm, attribute_search_detail_4_nm], '속성 탐색', 'cdjTable_3Tr_8Td')" style="border-right-width: 2px;">
                    {{ this.attribute_search_detail_5_rate }}
                  </td>
                  <b-tooltip target="cdjTable_3Tr_8Td" triggers="hover"> {{ Math.round(this.attribute_search_detail_5_freq).toLocaleString() }} </b-tooltip>
                  <td id="cdjTable_3Tr_9Td" class="cdjTable_3Tr_9Td" @click="loadInsightDataBottomTable('cdjDetails', buy_manage_detail_1_nm, 'cdjTable_3Tr_9Td')">
                    {{ this.buy_manage_detail_1_rate }}
                  </td>
                  <b-tooltip target="cdjTable_3Tr_9Td" triggers="hover"> {{ Math.round(this.buy_manage_detail_1_freq).toLocaleString() }} </b-tooltip>
                  <td id="cdjTable_3Tr_10Td" class="cdjTable_3Tr_10Td" @click="loadInsightDataBottomTable('cdjDetails', buy_manage_detail_2_nm, 'cdjTable_3Tr_10Td')" style="border-right-width: 2px;">
                    {{ this.buy_manage_detail_2_rate }}
                  </td>
                  <b-tooltip target="cdjTable_3Tr_10Td" triggers="hover"> {{ Math.round(this.buy_manage_detail_2_freq).toLocaleString() }} </b-tooltip>
                </tr>
              </table>
              <div style="position: relative; min-height: 500px;">
                <div id="loadingStack" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%; visibility: visible;">
                  <b-spinner class="align-middle mr-2"></b-spinner>
                  <strong>분석중...</strong>
                </div>
                <div class="graphic-container2" id="stackChart" style="visibility: hidden;">
                  <insight-chart-stack
                    :stackChartData="stackChartData"
                    :stackChartCategory="stackChartCategory"
                  />
                </div>  
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col xl="4" md="4" sm="4">
          <b-row style="margin-top: 1rem;">
            <b-col style="text-align: center; font-size: 2rem;">
              <h1>브랜드 맵</h1>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="text-align: center; color: #6B6B6B; margin-bottom: 0.3rem;">
              {{ this.mapHistory }}
            </b-col>
          </b-row>
          <b-row style="margin-top: -1rem;">
            <b-col id="insightTreeCol" style="position: relative; min-height: 190px;">
              <div id="loadingTree" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%; visibility: visible;">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>분석중...</strong>
              </div>
              <div id="treeChart" style="visibility: hidden;">
                <insight-chart-tree
                :treeChartData="treeChartData1"
                :treeChartGubun="treeChartGubun1"
                />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="text-align: center; font-size: 2rem;">
              <h1>검색량 상위 키워드 50</h1>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="text-align: center; color: #6B6B6B; margin-bottom: 0.3rem;">
              {{ this.mapHistory }}
            </b-col>
          </b-row>
          <b-row style="margin-top: 0.3rem;">
            <b-col>
              <b-table
                class="table2 position-relative mr-1 h-120"
                ref="refInsightTable2"
                :items="fetchGroups2"
                :fields="tableColumns2"
                :busy="isBusy2"
                :sort-desc.sync="sortDesc2" 
                :sort-by.sync="sortBy2"
                :sort-direction='sortDirection2'
                responsive
                show-empty
                no-border-collapse
                outlined
                head-variant="light"
                hover
                table-class="table-font-size"
                empty-text="해당하는 키워드가 없습니다."
                sticky-header="true"
                style="max-height: 24rem;"
              >
                <template #head()="{ label, field: { key, sortable } }">
                  {{ label }}
                  <template v-if="sortable">
                    <b-img v-if="sortBy2 !== key" src="/caretupdown.png" style="width: 10px; margin-top: -2px;"></b-img>
                    <b-img v-else-if="sortDesc2" src="/caretup.png" style="width: 9px;"></b-img>
                    <b-img v-else src="/caretdown.png" style="width: 9px;"></b-img>
                  </template>
                </template>
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>분석중...</strong>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="8" md="8" sm="8">
          <div v-if="this.stackChartData.length > 0" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-top: 5px; margin-bottom: 5px;">          
            <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
              <div v-if="this.stackChartData[0][0][0] != ''" style="margin-bottom: 4px;">
                <div v-if="this.stackChartData[1][0][0] != ''">
                  • <b>카테고리 탐색</b> 영역에서 가장 많이 검색된 내용은 <b>{{ this.general_search_detail_1_nm }}({{ this.general_search_detail_1_rate }})</b> 이며, 이 중 가장 많이 검색된 내용은 <b>{{ this.stackChartData[0][0][0] }}({{ this.stackChartData[0][2][0] }}%)</b> 입니다. 그 다음으로 많이 검색된 내용은 <b>{{ this.stackChartData[1][0][0] }}({{ this.stackChartData[1][2][0]}}%)</b>입니다. 
                </div>
                <div v-else>
                  • <b>카테고리 탐색</b> 영역에서 가장 많이 검색된 내용은 <b>{{ this.general_search_detail_1_nm }}({{ this.general_search_detail_1_rate }})</b> 이며, 이 중 가장 많이 검색된 내용은 <b>{{ this.stackChartData[0][0][0] }}({{ this.stackChartData[0][2][0] }}%)</b> 입니다. 
                </div>
              </div>  
              <div v-else>
                • <b>카테고리 탐색</b> 영역에서 가장 많이 검색된 내용은 <b>{{ this.general_search_detail_1_nm }}({{ this.general_search_detail_1_rate }})</b> 입니다. 
              </div>

              <div v-if="this.stackChartData[0][0][3] != ''" style="margin-bottom: 4px;">
                <div v-if="this.stackChartData[1][0][3] != ''">
                  <div v-if="this.stackChartData[2][0][3] != ''">
                    • <b>속성탐색</b> 영역에서 가장 많이 검색된 내용은 <b>{{ this.attribute_search_detail_1_nm }}({{ this.attribute_search_detail_1_rate }})</b> 이며, 이 중 가장 많이 검색된 내용은 <b>{{ this.stackChartData[0][0][3] }}({{ this.stackChartData[0][2][3] }}%)</b> 입니다. 그 다음으로 많이 검색된 내용은 <b>{{ this.stackChartData[1][0][3] }}({{ this.stackChartData[1][2][3] }}%)</b>, <b>{{ this.stackChartData[2][0][3] }}({{ this.stackChartData[2][2][3] }}%)</b> 입니다. 
                  </div>
                  <div v-else>
                    • <b>속성탐색</b> 영역에서 가장 많이 검색된 내용은 <b>{{ this.attribute_search_detail_1_nm }}({{ this.attribute_search_detail_1_rate }})</b> 이며, 이 중 가장 많이 검색된 내용은 <b>{{ this.stackChartData[0][0][3] }}({{ this.stackChartData[0][2][3] }}%)</b> 입니다. 그 다음으로 많이 검색된 내용은 <b>{{ this.stackChartData[1][0][3] }}({{ this.stackChartData[1][2][3] }}%)</b> 입니다. 
                  </div>
                </div>
                <div v-else>
                  • <b>속성탐색</b> 영역에서 가장 많이 검색된 내용은 <b>{{ this.attribute_search_detail_1_nm }}({{ this.attribute_search_detail_1_rate }})</b> 이며, 이 중 가장 많이 검색된 내용은 <b>{{ this.stackChartData[0][0][3] }}({{ this.stackChartData[0][2][3] }}%)</b> 입니다.
                </div>
              </div>    
              <div v-else>
                • <b>속성탐색</b> 영역에서 가장 많이 검색된 내용은 <b>{{ this.attribute_search_detail_1_nm }}({{ this.attribute_search_detail_1_rate }})</b> 입니다.
              </div>
              
              <div v-if="this.stackChartData[0][0][8] != ''" style="margin-bottom: 4px;">
                <div v-if="this.stackChartData[1][0][8] != ''" >
                  • <b>구매 및 관리</b> 영역에서 가장 많이 검색된 내용은 <b>{{ this.buy_manage_detail_1_nm }}({{ this.buy_manage_detail_1_rate }})</b> 이며, 이 중 가장 많이 검색된 내용은 <b>{{ this.stackChartData[0][0][8] }}({{ this.stackChartData[0][2][8] }}%)</b> 입니다. 그 다음으로 많이 검색된 내용은 <b>{{ this.stackChartData[1][0][8] }}({{ this.stackChartData[1][2][8] }}%)</b> 입니다. 
                </div>
                <div v-else>
                  • <b>구매 및 관리</b> 영역에서 가장 많이 검색된 내용은 <b>{{ this.buy_manage_detail_1_nm }}({{ this.buy_manage_detail_1_rate }})</b> 이며, 이 중 가장 많이 검색된 내용은 <b>{{ this.stackChartData[0][0][8] }}({{ this.stackChartData[0][2][8] }}%)</b> 입니다. 
                </div>
              </div> 
              <div v-else>
                • <b>구매 및 관리</b> 영역에서 가장 많이 검색된 내용은 <b>{{ this.buy_manage_detail_1_nm }}({{ this.buy_manage_detail_1_rate }})</b> 입니다. 
              </div>
            </div>
            <div style="color: #1951dc; margin-left: 5px;">
              👉 많은 탐색이 일어나는 키워드를 통해, 소비자의 니즈를 해결해 주는 제품/서비스와 콘텐츠를 기획할 수 있습니다. 
            </div>
          </div>
        </b-col>
        <b-col xl="4" md="4" sm="4">
          <div v-if="this.treeChartData1.length > 0" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-top: 5px; margin-bottom: 5px;">          
            <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
              <div v-if="this.mapHistory == 'TOTAL'" style="margin-bottom: 4px;">
                <div v-if="this.treeChartData1.length == 1">
                  • <b>전체</b>에서 가장 많이 검색된 브랜드는 <b>{{ this.treeChartData1[0].x }}({{ this.treeChartData1[0].y.toFixed(1) }}%)</b> 입니다.
                </div>
                <div v-else-if="this.treeChartData1.length == 2">
                  • <b>전체</b>에서 가장 많이 검색된 브랜드는 <b>{{ this.treeChartData1[0].x }}({{ this.treeChartData1[0].y.toFixed(1) }}%)</b> 이며, 그 뒤를 <b>{{ this.treeChartData1[1].x }}({{ this.treeChartData1[1].y.toFixed(1) }}%)</b> 가 뒤따르고 있습니다.
                </div>
                <div v-else-if="this.treeChartData1.length > 2">
                  • <b>전체</b>에서 가장 많이 검색된 브랜드는 <b>{{ this.treeChartData1[0].x }}({{ this.treeChartData1[0].y.toFixed(1) }}%)</b> 이며, 그 뒤를 <b>{{ this.treeChartData1[1].x }}({{ this.treeChartData1[1].y.toFixed(1) }}%)</b>, <b>{{ this.treeChartData1[2].x }}({{ this.treeChartData1[2].y.toFixed(1) }}%)</b> 가 뒤따르고 있습니다.
                </div>
              </div>
              <div v-else style="margin-bottom: 4px;">
                <div v-if="this.treeChartData1.length == 1">
                  • <b>{{ this.mapHistory }}</b>에서 가장 많이 검색된 브랜드는 <b>{{ this.treeChartData1[0].x }}({{ this.treeChartData1[0].y.toFixed(1) }}%)</b> 입니다.
                </div>
                <div v-else-if="this.treeChartData1.length == 2">
                  • <b>{{ this.mapHistory }}</b>에서 가장 많이 검색된 브랜드는 <b>{{ this.treeChartData1[0].x }}({{ this.treeChartData1[0].y.toFixed(1) }}%)</b> 이며, 그 뒤를 <b>{{ this.treeChartData1[1].x }}({{ this.treeChartData1[1].y.toFixed(1) }}%)</b> 가 뒤따르고 있습니다.
                </div>
                <div v-else-if="this.treeChartData1.length > 2">
                  • <b>{{ this.mapHistory }}</b>에서 가장 많이 검색된 브랜드는 <b>{{ this.treeChartData1[0].x }}({{ this.treeChartData1[0].y.toFixed(1) }}%)</b> 이며, 그 뒤를 <b>{{ this.treeChartData1[1].x }}({{ this.treeChartData1[1].y.toFixed(1) }}%)</b>, <b>{{ this.treeChartData1[2].x }}({{ this.treeChartData1[2].y.toFixed(1) }}%)</b> 가 뒤따르고 있습니다.
                </div>                
              </div>        
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-card ref="istPrintArea3" class="mb-1" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row style="margin-top: 1rem;">
        <b-col xl="3" md="3" sm="3">
        </b-col>
        <b-col style="text-align: center; font-size: 2rem;">
          <h1>인사이트 트래킹</h1>
        </b-col>
        <b-col xl="3" md="3" sm="3">
          <div class="d-flex justify-content-end">
            <v-select
              id="sel-type"
              label="기준"            
              dense
              outlined
              hide-details
              :items="insightTrkFilterList"
              v-model="selectedInsightTrkFilter"
              style="width: 100px; height: auto; font-size: 12px; font-weight: 500; margin: 5px; text-align: center !important;"
            >
            </v-select>
            <v-select
              id="sel-display"
              label="표시"            
              dense
              outlined
              hide-details
              :items="insightTrkDisplayType"
              v-model="selectedInsightTrkDisplayType"
              style="width: 100px; height: auto; font-size: 12px; font-weight: 500; margin: 5px; text-align: center !important;"
            >
            </v-select>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col style="text-align: center; color: #6B6B6B; margin-bottom: 0.3rem;">
          {{ this.mapHistory }}
        </b-col>
      </b-row>
      <b-row>
        <b-col style="text-align: center; color: #ea5455; margin-bottom: 1rem;">
          📢 위 표에서 선택한 열 또는 칸에 대한 브랜드와 키워드의 변화를 알 수 있습니다. 우측 필터에서 원하는 내용을 선택해주세요.
        </b-col>
      </b-row>
      <b-row>
        <b-col style="position: relative; min-height: 500px;">
          <div id="loadingLine" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%; visibility: visible;">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>분석중...</strong>
          </div>
          <div id="lineChart" style="visibility: hidden;">
            <insight-chart-line
              :insightChartLine="insightChartLineSeries(lineChartData)"
              :lineChartCategories="lineChartCategories"
              :lineChartDesc="lineChartDesc"
              :isChartInit="lnChartInit"
              id="insightChartLine"
            />
          </div>
          <div v-if="this.lineChartData.length > 0" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-top: 5px; margin-bottom: 5px;">          
            <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
              <div v-if="this.mapHistory == 'TOTAL'" style="margin-bottom: 4px;">
                • <b>전체 브랜드</b>에서 <b>{{ this.lineChartCategories[0] }} ~ {{ this.lineChartCategories[this.lineChartCategories.length - 1]}}</b> 기간 동안, <b>{{ this.top_freq_brand }}</b> 가 <b>{{ this.top_freq_date }}</b>에 <b>{{ this.top_freq_value.toLocaleString() }}</b> 건으로 가장 높은 검색량을 보였습니다.
              </div>
              <div v-else style="margin-bottom: 4px;">
                • <b>{{ this.mapHistory }}</b>에서 <b>{{ this.lineChartCategories[0] }} ~ {{ this.lineChartCategories[this.lineChartCategories.length - 1]}}</b> 기간 동안, <b>{{ this.top_freq_brand }}</b> 가 <b>{{ this.top_freq_date }}</b>에 <b>{{ this.top_freq_value.toLocaleString() }}</b> 건으로 가장 높은 검색량을 보였습니다.
              </div>        
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <compare-modal
      :compareBrandList= "compareBrandList"
      :compareFirstClasses= "compareFirstClasses"
      :compareMiddleClass= "compareMiddleClass"
      :compareDates= "compareDates"
      :compareBrand= "compareBrand"
      :compareShow1= "compareShow1"      
    />

  </section>
</template>



<script>
import { 
    BCard, 
    BCol, 
    BRow, 
    BCardBody, 
    BButton,
    BButtonGroup,
    BCardText,
    BFormRadio, 
    BTable, 
    BPagination,
    BFormGroup,
    BFormSelect,
    BFormRadioGroup,
    BTooltip,
    BSpinner,
    BImg,
} from "bootstrap-vue";

import FlatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/plugins/monthSelect/style.css'

import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'

//test
import ConfirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate.js';
import 'flatpickr/dist/plugins/confirmDate/confirmDate.css';


import vSelect from "vue-select";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

import InsightChartDonut from "@/views/cis-insight/components/InsightChartDonut.vue";
import InsightChartBar from "@/views/cis-insight/components/InsightChartBar.vue";
import InsightChartStack from "@/views/cis-insight/components/InsightChartStack.vue";

import InsightTable from "@/views/cis-insight/components/InsightTable";
import InsightChartTree from "@/views/cis-insight/components/InsightChartTree.vue";
import InsightChartLine from "@/views/cis-insight/components/InsightChartLine.vue";

import CisInsightService from "@/services/cis-insight.service";
import CategoryService from "@/services/category.service";

import ExportPDF from "@/components/pdfExport";
import debounce from "lodash";

import * as XLSX from 'xlsx';
import { integer } from "vee-validate/dist/rules";

import axios from "axios"

import useJwt from '@/auth/jwt/useJwt'

import CompareModal from "@/views/cis-insight/modal/CompareModal.vue";

const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

const boldStyle = { font: { name: 'Consolas', bold: true } };
const underlineStyle = { font: { name: 'Consolas', underline: true} };

const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

var sel_category = '9999';

export default {
  name: "Competition",
  components: {
    FlatPickr,
    BCard,
    BCol,
    BRow,
    BCardBody,
    vSelect,
    BButton,
    BButtonGroup,
    BTable,
    BPagination,
    BFormGroup,
    BFormSelect,
    BFormRadio, 
    BFormRadioGroup,
    BTooltip,
    BSpinner,
    BImg,

    InsightChartDonut,
    InsightChartBar,
    InsightChartStack,
    InsightChartTree,

    InsightChartLine,

    ConfirmDatePlugin,

    CompareModal,
  },
  data() {
    return {
      userData: useJwt.getUserData(),

      compareShow1: false,
      compareFirstClasses: [],
      compareMiddleClass: '',
      compareDates: [],
      compareBrand: '',      
      compareBrandList: [],


      isPdfExporting: false,
      isXlsExporting: false,

      maxDisplay: 1,

      selectedOptions: [],

      selectedDates: [],

      totalFreq: 0,

      donutChartData: [],
      barChartData: [],
      barChartFreq: [],
      barChartCategory: [],
      height: 0,

      stackChartData: [],
      stackChartCategory: [],

      brandList: [],
      firstClassList: [],
      middleClassList: [],

      selectedBrand: "",
      selectedBrandList: [],
      selectedFirstClasses: [],
      selectedMiddleClass: [],
      
      form: {
        monthSelect: []
      },
      configs: {
        monthSelect: {
          mode: "range",
          altFormat: 'Y-m',
          plugins: [
            new monthSelectPlugin({
              shorthand: true,
              dateFormat: "Y-m",
            }),
            new ConfirmDatePlugin({
            enableTime: true,
            plugins: [new ConfirmDatePlugin({})]
            })
          ],
          locale: {
            rangeSeparator: ' ~ '
          },
          minDate:"2018-01-01",
          maxDate: moment().endOf('month').format('YYYY-MM-DD') // 이번 달 말일로 지정
        }
      },
      
      selectedDisplayValue: {
          id: 1,
          title: "비율(%)"
      },
      selectedCDJ: "total",

      total_search_freq_upper: "",
      total_search_freq: "",
      general_search_freq_upper: "",
      general_search_freq: "",
      general_search_rate_upper: "",
      general_search_rate: "",
      general_search_detail_1_nm: "",
      general_search_detail_1_freq: "",
      general_search_detail_1_rate: "",
      general_search_detail_2_nm: "",
      general_search_detail_2_freq: "",
      general_search_detail_2_rate: "",
      general_search_detail_3_nm: "",
      general_search_detail_3_freq: "",
      general_search_detail_3_rate: "",
      attribute_search_freq_upper: "",
      attribute_search_freq: "",
      attribute_search_rate_upper: "",
      attribute_search_rate: "",
      attribute_search_detail_1_nm: "",
      attribute_search_detail_1_freq: "",
      attribute_search_detail_1_rate: "",
      attribute_search_detail_2_nm: "",
      attribute_search_detail_2_freq: "",
      attribute_search_detail_2_rate: "",
      attribute_search_detail_3_nm: "",
      attribute_search_detail_3_freq: "",
      attribute_search_detail_3_rate: "",
      attribute_search_detail_4_nm: "",
      attribute_search_detail_4_freq: "",
      attribute_search_detail_4_rate: "",
      attribute_search_detail_5_nm: "",
      attribute_search_detail_5_freq: "",
      attribute_search_detail_5_rate: "",
      buy_manage_freq_upper: "",
      buy_manage_freq: "",
      buy_manage_rate_upper: "",
      buy_manage_rate: "",
      buy_manage_detail_1_nm: "",
      buy_manage_detail_1_freq: "",
      buy_manage_detail_1_rate: "",
      buy_manage_detail_2_nm: "",
      buy_manage_detail_2_freq: "",
      buy_manage_detail_2_rate: "",

      tableColumns1: [
        { key: 'rank', label: '순위',  sortable: true, thClass: 'text-left w20', tdClass: 'text-center'},
        { key: 'keyword', label: '키워드', sortable: true , thClass: 'text-left'},
        { key: 'frequency', label: '검색량', sortable: true , thClass: 'text-right', tdClass: 'text-right'},
      ],

      fetchGroups1: null,

      tableColumns2: [
        { key: 'rank', label: '순위',  sortable: true, thClass: 'text-left', tdClass: 'text-center'},
        { key: 'keyword', label: '키워드', sortable: true , thClass: 'text-left' },
        { key: 'frequency', label: '검색량', sortable: true , thClass: 'text-right', tdClass: 'text-right'},
        { key: 'rate', label: '비율', sortable: true , thClass: 'text-right', tdClass: 'text-right'},
      ],

      fetchGroups2: null,

      treeChartData1: [],
      treeChartData2: [],
      treeChartGubun1: 'brandMap',
      treeChartGubun2: 'detailMap',

      mapHistory: "카테고리 탐색 > 단순 카테고리 탐색 > 무선청소기",
      mapUpperHistory: "TOTAL",

      lineChartCategories: [],
      lineChartData: [],
      lineChartDesc: [],

      gubun: '',
      cdjParam: '',
      etcList: [], 
      upperGubun: '',
      etc: false,

      presenceData: {
        dateType: "m"
      },

      donutChartInit: false,

      lnChartInit: false,

      isBusy1: false,
      isBusy2: false,

      insightTrkFilterList: ["브랜드", "키워드"],
      insightTrkDisplayType: ["비율(%)", "검색량"],

      selectedInsightTrkFilter: "브랜드",
      selectedInsightTrkDisplayType: "검색량",
      
      top_freq_brand: "",
      top_freq_date: "",
      top_freq_value: 0,

      sortBy1: null,
      sortBy2: null,
      sortDesc1: false,
      sortDesc2: false,
      sortDirection1: 'desc',
      sortDirection2: 'desc',
    };
  },
  computed: {
    check_selectedCategory(){
      return this.$store.getters.getSelectedCategory
    },

    check_selectedBrandInsightUpper() {
      return this.$store.getters.getSelectedBrandInsightUpper
    },

    isSelectAll_cond: {
      get() {
        return this.firstClassList.length == this.selectedFirstClasses.length 
      },
      set() {
      }
    },

    isSelectSome_cond: {
      get() {
        return this.selectedFirstClasses.length > 0
      },
      set() {
      }
    },
  },
  watch: {
    sortDesc1(val) {
      if(val)
        this.sortBy1 = null
    },

    sortDesc2(val) {
      if(val)
        this.sortBy2 = null
    },

    check_selectedCategory(val) {
      console.log('---------- watch // check_selectedCategory ----------')
      console.log(' sel category : ' + val)
      console.log(' cur category : ' + sel_category)

      if (sel_category != val) {
        this.abort(true, 'change category')

        sel_category = val;

        this.selectedOptions = []
        this.selectedBrandList = [];
        this.selectedFirstClasses = [];
        
        var st_dt = this.$store.getters.getSelectedPeriodSt
        var en_dt = this.$store.getters.getSelectedPeriodEn

        if (st_dt.length == 0 || en_dt.length == 0) {
          en_dt = moment().add(-2, 'days').toDate() // 데이터 업데이트 시점을 고려
          st_dt = new Date(en_dt)

          st_dt.setMonth(en_dt.getMonth() - 11)
        }

        this.form.monthSelect = [st_dt, en_dt]      

        this.selectedDisplayValue = {
          id: 1,
          title: "비율(%)"
        };

        this.selectedInsightTrkFilter = "브랜드";
        this.selectedInsightTrkDisplayType = "검색량";

        this.runAnalysis();
        this.setFirstClasses();
      }
    },

    async check_selectedBrandInsightUpper(selBrand) {
      this.isBusy1 = true
      this.fetchGroups1 = null     
      var firstClassList = []

      var startDate = moment(this.form.monthSelect[0]).format("YYYY-MM")
      var endDate = moment(this.form.monthSelect[1]).format("YYYY-MM")
     
      for(const item of this.selectedFirstClasses)
        firstClassList.push(item)

      const response = await CisInsightService.getInsightDataUpperTable({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList : [selBrand],
        firstClassList : firstClassList,        
        cdj : this.selectedCDJ
      }, source);

      if (response && response.status === 200) {
        console.log('-- 상단 키워드 data --')
        console.log(response)
        this.isBusy1 = false
        this.fetchGroups1 = null
        this.fetchGroups1 = response.data.data

        this.mapUpperHistory = this.selectedCDJ + " > " + selBrand;
      }
    },

    selectedBrandList(){
      this.selectedCDJ = "total"
    },

    selectedFirstClasses(){
      this.selectedCDJ = "total"
      this.selectedBrand = ""
    },

    selectedCDJ(){
      this.mapUpperHistory = this.selectedCDJ;
      this.loadInsightDataDonutBar();
      this.loadInsightDataUpperTable();
      // this.runAnalysis();
    },

    selectedBrand(){
      if(this.$store.getters.getSelectedCategory != '9999'){
        this.loadInsightDataCDJTableBottom();
        this.loadInsightDataBottomTable('total', '', '');
        this.loadInsightDataLine()
      }
    },

    selectedInsightTrkFilter() {
      this.loadInsightDataLine();
    },

    selectedInsightTrkDisplayType() {
      this.$store.dispatch('callInsightDisplayType', { displayType: this.selectedInsightTrkDisplayType });
    },
  },
  methods: {
    compareInsight(){
      console.log('-- compareInsight --')
      this.compareShow1 = true
      this.compareFirstClasses = this.selectedFirstClasses
      this.compareMiddleClass = this.selectedMiddleClass
      this.compareDates = this.selectedDates
      this.compareBrand = this.selectedBrand
      this.compareBrandList = this.brandList

      this.$nextTick(() => {
        this.$bvModal.show("compare-modal");
      });
    },

    changeCompareShow1(){
      this.compareShow1 = false
    },

    clickCDJBtn(cdj){
      this.selectedCDJ = cdj;
    },

    datePickerOnOpen(selectedDates, dateStr, instance) {
      if (document.querySelector(".fp-max-duration-info") == null) {
        var divEl = document.createElement("div"); 
        divEl.setAttribute('class', 'fp-max-duration-info');   
        divEl.setAttribute('align', 'left');   
        divEl.setAttribute('style', 'margin: 2px 10px; font-family: NanumBarunGothic; font-size: 12px; font-weight: 600; color: #17a2b8;');   
        divEl.innerHTML = "&#9888; 분석기간은 최대 3년 입니다.";
        document.querySelector(".flatpickr-calendar").appendChild(divEl);
      }
    },

    datePickerOnChange(selectedDates, dateStr, instance) {
      instance.element.value = dateStr.replace('to', '~')

      var [st_dt, en_dt] = selectedDates;
      
      if (en_dt == null) {
        var newMindate = moment(st_dt).add(-35, 'month')
        var newMaxdate = moment(st_dt).add( 35, 'month')

        if (newMindate.isBefore(this.configs.monthSelect.minDate)) 
          newMindate = moment(this.configs.monthSelect.minDate);

        if (newMaxdate.isAfter(this.configs.monthSelect.maxDate)) 
          newMaxdate = moment(this.configs.monthSelect.maxDate);

        instance.config.minDate = newMindate.toDate()
        instance.config.maxDate = newMaxdate.toDate()
      }
    },

    datepickerCloseHandler(selectedDates, dateStr, instance) {
      var [st_dt, en_dt] = selectedDates;

      if (en_dt) {
        var diff_month = (en_dt.getYear() - st_dt.getYear()) * 12 + (en_dt.getMonth() - st_dt.getMonth() + 1);

        if (diff_month > 36) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "설정 가능한 최대 분석 기간은 3년(36개월)입니다." || "Unknown error",
              icon: "AlertCircleIcon",
              variant: "warning",
            },
          });

          var curr_dt = new Date()
          var avail_diff_month = (curr_dt.getYear() - st_dt.getYear()) * 12 + (curr_dt.getMonth() - st_dt.getMonth());

          if (avail_diff_month > 35)
            avail_diff_month = 35
          
          en_dt = moment(st_dt).add(avail_diff_month, 'month').toDate()

          this.form.monthSelect = [st_dt, en_dt]
        }
        else
          this.form.monthSelect = selectedDates;

        var st_dt_str = moment(st_dt).format("YYYY-MM")
        var en_dt_str = moment(en_dt).format("YYYY-MM")

        if(this.selectedDates[0] != st_dt_str || this.selectedDates[1] != en_dt_str){
          this.selectedDates = []
          this.selectedDates.push(st_dt_str)
          this.selectedDates.push(en_dt_str)
          this.preAnalysisPeriod = [st_dt_str, en_dt_str]
          this.comAnalysisPeriod = [st_dt_str, en_dt_str]
          this.purAnalysisPeriod = [st_dt_str, en_dt_str]

          this.curMonthIdx = moment(en_dt_str).diff(moment(st_dt_str), 'month');
          this.curYearIdx = moment(en_dt_str.substr(0,4)).diff(moment(st_dt_str.substr(0,4)), 'years');   

          this.$store.dispatch('callPeriodSt', { st_dt: st_dt })
          this.$store.dispatch('callPeriodEn', { en_dt: en_dt })          
        }      
      }
      else
        instance.setDate([this.form.monthSelect[0], this.form.monthSelect[1]], true)
    },

    async setFirstClasses() {
      console.log('---------- setFirstClasses ----------')

      this.firstClassList = [];
      this.selectedFirstClasses = [];

      // 카테고리 정보가 설정되지 않은 경우 리턴
      if (sel_category == '9999' && this.$store.getters.getSelectedCategory == '9999') 
        return;

      sel_category = this.$store.getters.getSelectedCategory;

      const firstClasses = await CisInsightService.listFirstClass({ctgSq: this.$store.getters.getSelectedCategory}, source);

      if (firstClasses.data.success) {
        console.log('---------- Major Classes list ----------')
        console.log(firstClasses.data.data)

        this.firstClassList = firstClasses.data.data;
      }
    },

    async setMiddleClasses() {
      console.log('---------- setMiddleClasses ----------')

      this.middleClassList = [];
      this.selectedMiddleClass = null;

      // 카테고리 정보가 설정되지 않은 경우 리턴
      if (sel_category == '9999' && this.$store.getters.getSelectedCategory == '9999') 
        return;

      sel_category = this.$store.getters.getSelectedCategory;

      var st_dt_str = moment(this.form.monthSelect[0]).format("YYYY-MM")
      var en_dt_str = moment(this.form.monthSelect[1]).add(1, 'month').format("YYYY-MM")

      var firstClassList = []

      for(const item of this.selectedFirstClasses)
        firstClassList.push(item)

      const middleClasses = await CisInsightService.getMiddleClasslist({
        st_dt: st_dt_str,
        en_dt: en_dt_str,
        ctgSq: this.$store.getters.getSelectedCategory, 
        selMajorList: firstClassList
      }, source);

      if (middleClasses.data.success) {
        console.log('---------- Middle Classes list ----------')
        console.log(middleClasses.data.data)

        this.middleClassList = middleClasses.data.data; 

        var _idx = this.middleClassList.findIndex((element) => element == "기타");

        if (_idx >= 0) {
          this.middleClassList = this.middleClassList.with(_idx, "중분류 없음")
          this.middleClassList.sort()
        }
      }
    },

    async setBrandList(){
      this.brandList = []
      var firstClassList = []

      for(const item of this.selectedFirstClasses)
        firstClassList.push(item)

      const brandList = await CisInsightService.listBrand({
        ctgSq: this.$store.getters.getSelectedCategory,
        firstClassList : firstClassList
      }, source);

      if (brandList.data.success) {
        for(const item of brandList.data.data)
          this.brandList.push(item.title)
      }
    },

    async loadInsightDataDonutBar(){
      console.log('loadInsightDataDonutBar')

      document.getElementById('loadingDonut').style.visibility = "visible";
      document.getElementById('donutChart').style.visibility = "hidden";
      document.getElementById('loadingBar').style.visibility = "visible";
      document.getElementById('barChart').style.visibility = "hidden";
      
      this.donutChartData = []
      this.barChartData = []
      this.barChartFreq = []
      this.barChartCategory = []
      this.donutChartInit = false;

      var startDate = moment(this.form.monthSelect[0]).format("YYYY-MM")
      var endDate = moment(this.form.monthSelect[1]).add(1, 'month').format("YYYY-MM")

      var firstClassList = []

      for(const item of this.selectedFirstClasses)
        firstClassList.push(item)

      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      const response = await CisInsightService.getInsightDataDonutBar({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList : this.selectedBrandList,
        firstClassList : firstClassList,
        selMiddle: sel_Middle,        
        cdj : this.selectedCDJ
      }, source);

      if (response && response.status === 200) {
        console.log('-- 상단 도넛, 바 data -- ')
        console.log(response)

        this.donutChartInit = true;
        this.loadingDonut = false

        // total freq update
        this.totalFreq = response.data.data.donutData[0].totalFreq

        // donut chart update
        this.donutChartData = [response.data.data.donutData[0].brandedFreq, response.data.data.donutData[0].nonbrandedFreq]

        // bar chart update
        this.barChartData = []
        this.barChartFreq = []
        this.barChartCategory = []

        for(const item of response.data.data.barData) {
          this.barChartCategory.push(item.brand)
          this.barChartData.push(item.rate)
          this.barChartFreq.push(item.freq)
        }

        document.getElementById('loadingDonut').style.visibility = "hidden";
        document.getElementById('donutChart').style.visibility = "visible";
        document.getElementById('loadingBar').style.visibility = "hidden";
        document.getElementById('barChart').style.visibility = "visible";
      }
    },

    async loadInsightDataCDJTableUpper(){
      console.log('loadInsightDataCDJTableUpper')

      var startDate = moment(this.form.monthSelect[0]).format("YYYY-MM")
      var endDate = moment(this.form.monthSelect[1]).add(1, 'month').format("YYYY-MM")

      var firstClassList = []

      for(const item of this.selectedFirstClasses)
        firstClassList.push(item)

      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      const response = await CisInsightService.getInsightDataCDJTable({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList : this.selectedBrandList,
        firstClassList : firstClassList,
        selMiddle: sel_Middle, 
      }, source);

      if (response && response.status === 200) {
        console.log('-- CDJ 테이블 data --')
        console.log(response)

        this.total_search_freq_upper = Math.round((response.data.data[0].freq + response.data.data[1].freq + response.data.data[2].freq + response.data.data[3].freq + response.data.data[4].freq + response.data.data[5].freq + response.data.data[6].freq + response.data.data[7].freq + response.data.data[8].freq + response.data.data[9].freq)*100)/100

        this.general_search_freq_upper = Math.round((response.data.data[0].freq + response.data.data[1].freq + response.data.data[2].freq)*100)/100
        this.general_search_rate_upper = Math.round((response.data.data[0].rate + response.data.data[1].rate + response.data.data[2].rate)*100)/100
        this.general_search_rate_upper = this.general_search_rate_upper + "%"

        this.attribute_search_freq_upper = Math.round((response.data.data[3].freq + response.data.data[4].freq + response.data.data[5].freq + response.data.data[6].freq + response.data.data[7].freq)*100)/100
        this.attribute_search_rate_upper = Math.round((response.data.data[3].rate + response.data.data[4].rate + response.data.data[5].rate + response.data.data[6].rate + response.data.data[7].rate)*100)/100
        this.attribute_search_rate_upper = this.attribute_search_rate_upper + "%"

        this.buy_manage_freq_upper = Math.round((response.data.data[8].freq + response.data.data[9].freq)*100)/100
        this.buy_manage_rate_upper = Math.round((response.data.data[8].rate + response.data.data[9].rate)*100)/100
        this.buy_manage_rate_upper = this.buy_manage_rate_upper + "%"
      }
    },

    async loadInsightDataCDJTableBottom(){
      console.log('loadInsightDataCDJTableBottom')

      var startDate = moment(this.form.monthSelect[0]).format("YYYY-MM")
      var endDate = moment(this.form.monthSelect[1]).add(1, 'month').format("YYYY-MM")

      var firstClassList = []
      for(const item of this.selectedFirstClasses)
        firstClassList.push(item)

      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      var brandList = []
      if(this.selectedBrand != '' && this.selectedBrand != null )
        brandList.push(this.selectedBrand)

      // stackChart 초기화
      this.stackChartData = []
      this.stackChartCategory = []
      document.getElementById('loadingStack').style.visibility = "visible";
      document.getElementById('stackChart').style.visibility = "hidden";
      // tree 초기화
      document.getElementById('loadingTree').style.visibility = "visible";
      document.getElementById('treeChart').style.visibility = "hidden";
      // line 초기화
      document.getElementById('loadingLine').style.visibility = "visible";
      document.getElementById('lineChart').style.visibility = "hidden";

      const response = await CisInsightService.getInsightDataCDJTable({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList : brandList,
        firstClassList : firstClassList,
        selMiddle: sel_Middle
      }, source);

      if (response && response.status === 200) {
        console.log('-- CDJ 테이블 data --')
        console.log(response)

        this.total_search_freq = Math.round((response.data.data[0].freq + response.data.data[1].freq + response.data.data[2].freq + response.data.data[3].freq + response.data.data[4].freq + response.data.data[5].freq + response.data.data[6].freq + response.data.data[7].freq + response.data.data[8].freq + response.data.data[9].freq)*100)/100
        this.general_search_freq = Math.round((response.data.data[0].freq + response.data.data[1].freq + response.data.data[2].freq)*100)/100
        this.general_search_rate = Math.round((response.data.data[0].rate + response.data.data[1].rate + response.data.data[2].rate))
        this.general_search_rate = this.general_search_rate + "%"
        this.attribute_search_freq = Math.round((response.data.data[3].freq + response.data.data[4].freq + response.data.data[5].freq + response.data.data[6].freq + response.data.data[7].freq)*100)/100
        this.attribute_search_rate = Math.round((response.data.data[3].rate + response.data.data[4].rate + response.data.data[5].rate + response.data.data[6].rate + response.data.data[7].rate))
        this.attribute_search_rate = this.attribute_search_rate + "%"
        this.buy_manage_freq = Math.round((response.data.data[8].freq + response.data.data[9].freq)*100)/100
        this.buy_manage_rate = Math.round((response.data.data[8].rate + response.data.data[9].rate))
        this.buy_manage_rate = this.buy_manage_rate + "%"

        this.general_search_detail_1_nm = response.data.data[0].cdjDetails
        this.general_search_detail_1_freq = response.data.data[0].freq
        this.general_search_detail_1_rate = response.data.data[0].rate
        this.general_search_detail_1_rate = this.general_search_detail_1_rate +"%"
        this.general_search_detail_2_nm = response.data.data[1].cdjDetails
        this.general_search_detail_2_freq = response.data.data[1].freq
        this.general_search_detail_2_rate = response.data.data[1].rate
        this.general_search_detail_2_rate = this.general_search_detail_2_rate + "%"
        this.general_search_detail_3_nm = response.data.data[2].cdjDetails
        this.general_search_detail_3_freq = response.data.data[2].freq
        this.general_search_detail_3_rate = response.data.data[2].rate
        this.general_search_detail_3_rate = this.general_search_detail_3_rate + "%"

        this.attribute_search_detail_1_nm = response.data.data[3].cdjDetails
        this.attribute_search_detail_1_freq = response.data.data[3].freq
        this.attribute_search_detail_1_rate = response.data.data[3].rate
        this.attribute_search_detail_1_rate = this.attribute_search_detail_1_rate + "%"
        this.attribute_search_detail_2_nm = response.data.data[4].cdjDetails
        this.attribute_search_detail_2_freq = response.data.data[4].freq
        this.attribute_search_detail_2_rate = response.data.data[4].rate
        this.attribute_search_detail_2_rate = this.attribute_search_detail_2_rate + "%"
        this.attribute_search_detail_3_nm = response.data.data[5].cdjDetails
        this.attribute_search_detail_3_freq = response.data.data[5].freq
        this.attribute_search_detail_3_rate = response.data.data[5].rate
        this.attribute_search_detail_3_rate = this.attribute_search_detail_3_rate +"%"
        this.attribute_search_detail_4_nm = response.data.data[6].cdjDetails
        this.attribute_search_detail_4_freq = response.data.data[6].freq
        this.attribute_search_detail_4_rate = response.data.data[6].rate
        this.attribute_search_detail_4_rate = this.attribute_search_detail_4_rate +"%"
        this.attribute_search_detail_5_nm = response.data.data[7].cdjDetails
        this.attribute_search_detail_5_freq = response.data.data[7].freq
        this.attribute_search_detail_5_rate = response.data.data[7].rate
        this.attribute_search_detail_5_rate = this.attribute_search_detail_5_rate +"%"

        this.buy_manage_detail_1_nm = response.data.data[8].cdjDetails
        this.buy_manage_detail_1_freq = response.data.data[8].freq
        this.buy_manage_detail_1_rate = response.data.data[8].rate
        this.buy_manage_detail_1_rate = this.buy_manage_detail_1_rate +"%"
        this.buy_manage_detail_2_nm = response.data.data[9].cdjDetails
        this.buy_manage_detail_2_freq = response.data.data[9].freq
        this.buy_manage_detail_2_rate = response.data.data[9].rate
        this.buy_manage_detail_2_rate = this.buy_manage_detail_2_rate + "%"

        var max_rate = 0

        for(const item of response.data.data){
          if(item.rate > max_rate)
            max_rate = item.rate
        }

        // stackedChart
        this.loadInsightDataStacked(response.data.data, max_rate);
      }
    },

    async loadInsightDataStacked(cdjTableData, maxRate){
      console.log('loadInsightDataStacked')

      this.stackChartData = []

      // stacked chart category setting
      this.stackChartCategory = []

      for(const item of cdjTableData)
        this.stackChartCategory.push(item.cdjDetails)

      var startDate = moment(this.form.monthSelect[0]).format("YYYY-MM")
      var endDate = moment(this.form.monthSelect[1]).add(1, 'month').format("YYYY-MM")

      var firstClassList = []

      for(const item of this.selectedFirstClasses)
        firstClassList.push(item)

      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      var brandList = []

      if(this.selectedBrand != '' && this.selectedBrand != null )      
        brandList.push(this.selectedBrand)

      const response = await CisInsightService.getInsightDataStacked({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList : brandList,
        firstClassList : firstClassList,
        selMiddle: sel_Middle, 
        cdjDetail1 : this.stackChartCategory[0],
        cdjDetail2 : this.stackChartCategory[1],
        cdjDetail3 : this.stackChartCategory[2],
        cdjDetail4 : this.stackChartCategory[3],
        cdjDetail5 : this.stackChartCategory[4],
        cdjDetail6 : this.stackChartCategory[5],
        cdjDetail7 : this.stackChartCategory[6],
        cdjDetail8 : this.stackChartCategory[7],
        cdjDetail9 : this.stackChartCategory[8],
        cdjDetail10 : this.stackChartCategory[9]
      }, source);

      if (response && response.status === 200) {
        console.log('-- 중단 Stacked data --')
        console.log(response)

        // min height 설정
        var minHeight = Math.round((100/9)*100)/100

        // stacked chart update
        this.stackChartData = []
        var stackDatas = []

        for(const item of response.data.data) {
          var keywords = item.keyword.split(',')
          var freqs = item.freq.split(',')
          var rates = item.rate.split(',')
          var heights = []

          for (var i = 0; i < freqs.length; i++) {
            if (freqs[i] == 0 && rates[i] == 0)
              heights.push(0)
            else
              heights.push(minHeight)
          }

          stackDatas = []
          stackDatas.push(keywords)
          stackDatas.push(freqs)
          stackDatas.push(rates)
          stackDatas.push(heights)

          this.stackChartData.push(stackDatas)
        }
        document.getElementById('loadingStack').style.visibility = "hidden";
        document.getElementById('stackChart').style.visibility = "visible";
      }
    },

    async loadInsightDataUpperTable(){
      console.log('loadInsightDataUpperTable')

      this.isBusy1 = true
      this.fetchGroups1 = null

      var startDate = moment(this.form.monthSelect[0]).format("YYYY-MM")
      var endDate = moment(this.form.monthSelect[1]).add(1, 'month').format("YYYY-MM")
      
      var firstClassList = []

      for(const item of this.selectedFirstClasses)
        firstClassList.push(item)

      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      const response = await CisInsightService.getInsightDataUpperTable({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList : this.selectedBrandList,
        firstClassList : firstClassList,    
        selMiddle: sel_Middle,     
        cdj : this.selectedCDJ
      }, source);

      if (response && response.status === 200) {
        console.log('-- 상단 키워드 data --')
        console.log(response)

        this.isBusy1 = false
        this.fetchGroups1 = null
        this.fetchGroups1 = response.data.data
      }
    },
    
    async loadInsightDataBottomTable(gubun, cdjParam, tdId){
      console.log('loadInsightDataBottomTable')

      // tree 초기화
      document.getElementById('loadingTree').style.visibility = "visible";
      document.getElementById('treeChart').style.visibility = "hidden";
      // line 초기화
      document.getElementById('loadingLine').style.visibility = "visible";
      document.getElementById('lineChart').style.visibility = "hidden";

      document.getElementById('cdjTable_1Tr_1Th').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_1Tr_1Th').style.color = "#3E3C45"
      document.getElementById('cdjTable_2Tr_1Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_2Tr_1Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_2Tr_2Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_2Tr_2Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_2Tr_3Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_2Tr_3Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_3Tr_1Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_3Tr_1Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_3Tr_2Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_3Tr_2Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_3Tr_3Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_3Tr_3Td').style.color = "#3E3C45"

      document.getElementById('cdjTable_1Tr_2Th').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_1Tr_2Th').style.color = "#3E3C45"
      document.getElementById('cdjTable_2Tr_4Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_2Tr_4Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_2Tr_5Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_2Tr_5Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_2Tr_6Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_2Tr_6Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_2Tr_7Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_2Tr_7Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_2Tr_8Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_2Tr_8Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_3Tr_4Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_3Tr_4Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_3Tr_5Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_3Tr_5Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_3Tr_6Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_3Tr_6Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_3Tr_7Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_3Tr_7Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_3Tr_8Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_3Tr_8Td').style.color = "#3E3C45"

      document.getElementById('cdjTable_1Tr_3Th').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_1Tr_3Th').style.color = "#3E3C45"
      document.getElementById('cdjTable_2Tr_9Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_2Tr_9Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_2Tr_10Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_2Tr_10Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_3Tr_9Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_3Tr_9Td').style.color = "#3E3C45"
      document.getElementById('cdjTable_3Tr_10Td').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_3Tr_10Td').style.color = "#3E3C45"

      document.getElementById('cdjTable_1Tr_4Th').style.backgroundColor = "#F2F2F2"
      document.getElementById('cdjTable_1Tr_4Th').style.color = "#3E3C45"

      if(tdId != ''){
        document.getElementById(tdId).style.backgroundColor = "#1817E7"
        document.getElementById(tdId).style.color = "#F2F2F2"
      }

      this.isBusy2 = true

      var startDate = moment(this.form.monthSelect[0]).format("YYYY-MM")
      var endDate = moment(this.form.monthSelect[1]).add(1, 'month').format("YYYY-MM")
      
      var firstClassList = []

      for(const item of this.selectedFirstClasses) {
        firstClassList.push(item)
      }

      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      var brandList = []

      if(this.selectedBrand != '' && this.selectedBrand != null ){        
        brandList.push(this.selectedBrand)
      }

      this.gubun = gubun
      this.cdjParam = cdjParam
      this.etc = false

      // 중단 상위키워드 50
      const response = await CisInsightService.getInsightDataBottomTable({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList : brandList,
        firstClassList : firstClassList,     
        selMiddle: sel_Middle,    
        gubun : gubun,
        cdjParam : cdjParam
      }, source);

      if (response && response.status === 200) {
        console.log('-- 중단 키워드 data --')
        console.log(response)

        this.isBusy2 = false
        this.fetchGroups2 = null
        this.fetchGroups2 = response.data.data
      }

      // 하단 mapHistory
      const mapHistoryResponse = await CisInsightService.getMapHistory({
        gubun : gubun,
        ctgSq : this.$store.getters.getSelectedCategory,
        cdjParam : cdjParam
      }, source);

      if (mapHistoryResponse && mapHistoryResponse.status === 200) {
        console.log('-- 하단 MapHistory data --')
        console.log(mapHistoryResponse)

        if(mapHistoryResponse.data.data[0].cdjContent != ''){
          this.mapHistory = mapHistoryResponse.data.data[0].cdj + ' > ' + mapHistoryResponse.data.data[0].cdjDetails + ' > ' + mapHistoryResponse.data.data[0].cdjContent
        }else if(mapHistoryResponse.data.data[0].cdjDetails != ''){
          this.mapHistory = mapHistoryResponse.data.data[0].cdj + ' > ' + mapHistoryResponse.data.data[0].cdjDetails
        }else{
          this.mapHistory = mapHistoryResponse.data.data[0].cdj
        }
      }

      // 하단 브랜드맵
      const brandMapresponse = await CisInsightService.getInsightDataBrandMap({
        startDate : startDate,
        endDate : endDate,
        ctgSq : this.$store.getters.getSelectedCategory,
        brandList : brandList,
        firstClassList : firstClassList,     
        selMiddle: sel_Middle,    
        gubun : gubun,
        cdjParam : cdjParam
      }, source);

      if (brandMapresponse && brandMapresponse.status === 200) {
        console.log('-- 하단 브랜드맵 data --')
        console.log(brandMapresponse)

        this.treeChartData1 = brandMapresponse.data.data

        document.getElementById('loadingTree').style.visibility = "hidden";
        document.getElementById('treeChart').style.visibility = "visible";
      }

      // 하단 라인 차트
      this.loadInsightDataLine()
    },

    async loadInsightDataLine(){
      console.log('loadInsightDataLine')

      document.getElementById('loadingLine').style.visibility = "visible";
      document.getElementById('lineChart').style.visibility = "hidden";

      this.lnChartInit = false;
      this.lineChartData = []
      this.lineChartCategories = []
      this.lineChartDesc = []

      var startDate = moment(this.form.monthSelect[0]).format("YYYY-MM")
      var endDate = moment(this.form.monthSelect[1]).add(1, 'month').format("YYYY-MM")

      var firstClassList = []

      for(const item of this.selectedFirstClasses) {
        firstClassList.push(item)
      }

      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      var brandList = []

      if(this.selectedBrand != '' && this.selectedBrand != null ){        
        brandList.push(this.selectedBrand)
      }

      var lineResponse = null

      if(this.etc){
        if(this.upperGubun == '기타'){
          var upperGubun = [this.attribute_search_detail_1_nm, this.attribute_search_detail_2_nm, this.attribute_search_detail_3_nm, this.attribute_search_detail_4_nm, '구매 후 관리', '추천/순위/종류', '비교/후기', '단순 카테고리 탐색', '가격 및 구매처 탐색']
          if(this.selectedInsightTrkFilter == "브랜드"){
            lineResponse = await CisInsightService.getInsightDataLineBrandETCETC({
              startDate : startDate,
              endDate : endDate,
              ctgSq : this.$store.getters.getSelectedCategory,
              brandList : brandList,
              firstClassList : firstClassList,
              selMiddle: sel_Middle, 
              gubun : this.gubun,
              etcList : this.etcList,
              upperGubun : upperGubun
            }, source);
          }else{
            lineResponse = await CisInsightService.getInsightDataLineDetailETCETC({
              startDate : startDate,
              endDate : endDate,
              ctgSq : this.$store.getters.getSelectedCategory,
              brandList : brandList,
              firstClassList : firstClassList,
              selMiddle: sel_Middle, 
              gubun : this.gubun,
              etcList : this.etcList,
              upperGubun : upperGubun
            }, source);
          }
        }else{
          if(this.selectedInsightTrkFilter == "브랜드"){
            lineResponse = await CisInsightService.getInsightDataLineBrandETC({
              startDate : startDate,
              endDate : endDate,
              ctgSq : this.$store.getters.getSelectedCategory,
              brandList : brandList,
              firstClassList : firstClassList,
              selMiddle: sel_Middle, 
              gubun : this.gubun,
              etcList : this.etcList,
              upperGubun : this.upperGubun
            }, source);
          }else{
            lineResponse = await CisInsightService.getInsightDataLineDetailETC({
              startDate : startDate,
              endDate : endDate,
              ctgSq : this.$store.getters.getSelectedCategory,
              brandList : brandList,
              firstClassList : firstClassList,
              selMiddle: sel_Middle, 
              gubun : this.gubun,
              etcList : this.etcList,
              upperGubun : this.upperGubun
            }, source);
          }
        }
      }else{
        if(this.selectedInsightTrkFilter == "브랜드"){
          lineResponse = await CisInsightService.getInsightDataLineBrand({
            startDate : startDate,
            endDate : endDate,
            ctgSq : this.$store.getters.getSelectedCategory,
            brandList : brandList,
            firstClassList : firstClassList,
            selMiddle: sel_Middle, 
            gubun : this.gubun,
            cdjParam : this.cdjParam
          }, source);
        }else{
          lineResponse = await CisInsightService.getInsightDataLineDetail({
            startDate : startDate,
            endDate : endDate,
            ctgSq : this.$store.getters.getSelectedCategory,
            brandList : brandList,
            firstClassList : firstClassList,
            selMiddle: sel_Middle, 
            gubun : this.gubun,
            cdjParam : this.cdjParam
          }, source);
        }
      }
      
      if (lineResponse && lineResponse.status === 200) {
        console.log('-- 하단 Line data --')
        console.log(lineResponse)
        
        this.lnChartInit = true;
        this.lineChartData = []
        this.lineChartCategories = []
        this.lineChartDesc = []

        var lineNum = 0

        for(const item of lineResponse.data.data) {
          lineNum+=1

          if(lineNum < 6){
            this.lineChartData.push({
              name: item.name,
              type: 'line',
              data: item.rate.split(','),
              description: item.freq.split(','),
              hidden: false
            })
          }else{
            this.lineChartData.push({
              name: item.name,
              type: 'line',
              data: item.rate.split(','),
              description: item.freq.split(','),
              hidden: true
            })
          }
          
          if (this.lineChartCategories.length == 0) {
            this.lineChartCategories = item.date.split(',')
          }

          this.lineChartDesc.push(item.freq.split(','))
        }

        // 조회 기간 동안 최대 검색량을 기록한 브랜드 및 날짜 정보를 획득 
        this.top_freq_brand = "";
        this.top_freq_date = "";
        this.top_freq_value = 0;

        for(var item of this.lineChartData) {
          var index = 0;

          for(var freq of item.description) {
            if(parseInt(freq) > this.top_freq_value) {
              this.top_freq_value = parseInt(freq)
              this.top_freq_brand = item.name
              this.top_freq_date = this.lineChartCategories[index]
            }
            
            index++;
          }
        }
        document.getElementById('loadingLine').style.visibility = "hidden";
        document.getElementById('lineChart').style.visibility = "visible";
      }
    },

    async loadInsightDataBottomTableETC(gubun, etcList, upperGubun, tdId){
      console.log('loadInsightDataBottomTableETC')
      console.log(upperGubun)

      if(tdId != ''){
        document.getElementById('cdjTable_1Tr_1Th').style.backgroundColor = "#F2F2F2"
        document.getElementById('cdjTable_1Tr_1Th').style.color = "#3E3C45"
        document.getElementById('cdjTable_2Tr_1Td').style.backgroundColor = "#F2F2F2"
        document.getElementById('cdjTable_2Tr_1Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_2Tr_2Td').style.backgroundColor = "#F2F2F2"
        document.getElementById('cdjTable_2Tr_2Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_2Tr_3Td').style.backgroundColor = "#F2F2F2"
        document.getElementById('cdjTable_2Tr_3Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_3Tr_1Td').style.backgroundColor = "#F2F2F2"
        document.getElementById('cdjTable_3Tr_1Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_3Tr_2Td').style.backgroundColor = "#F2F2F2"
        document.getElementById('cdjTable_3Tr_2Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_3Tr_3Td').style.backgroundColor = "#F2F2F2"
        document.getElementById('cdjTable_3Tr_3Td').style.color = "#3E3C45"

        document.getElementById('cdjTable_1Tr_2Th').style.backgroundColor = "#D9D9D9"
        document.getElementById('cdjTable_1Tr_2Th').style.color = "#3E3C45"
        document.getElementById('cdjTable_2Tr_4Td').style.backgroundColor = "#D9D9D9"
        document.getElementById('cdjTable_2Tr_4Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_2Tr_5Td').style.backgroundColor = "#D9D9D9"
        document.getElementById('cdjTable_2Tr_5Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_2Tr_6Td').style.backgroundColor = "#D9D9D9"
        document.getElementById('cdjTable_2Tr_6Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_2Tr_7Td').style.backgroundColor = "#D9D9D9"
        document.getElementById('cdjTable_2Tr_7Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_2Tr_8Td').style.backgroundColor = "#D9D9D9"
        document.getElementById('cdjTable_2Tr_8Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_3Tr_4Td').style.backgroundColor = "#D9D9D9"
        document.getElementById('cdjTable_3Tr_4Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_3Tr_5Td').style.backgroundColor = "#D9D9D9"
        document.getElementById('cdjTable_3Tr_5Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_3Tr_6Td').style.backgroundColor = "#D9D9D9"
        document.getElementById('cdjTable_3Tr_6Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_3Tr_7Td').style.backgroundColor = "#D9D9D9"
        document.getElementById('cdjTable_3Tr_7Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_3Tr_8Td').style.backgroundColor = "#D9D9D9"
        document.getElementById('cdjTable_3Tr_8Td').style.color = "#3E3C45"

        document.getElementById('cdjTable_1Tr_3Th').style.backgroundColor = "#BFBFBF"
        document.getElementById('cdjTable_1Tr_3Th').style.color = "#3E3C45"
        document.getElementById('cdjTable_2Tr_9Td').style.backgroundColor = "#BFBFBF"
        document.getElementById('cdjTable_2Tr_9Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_2Tr_10Td').style.backgroundColor = "#BFBFBF"
        document.getElementById('cdjTable_2Tr_10Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_3Tr_9Td').style.backgroundColor = "#BFBFBF"
        document.getElementById('cdjTable_3Tr_9Td').style.color = "#3E3C45"
        document.getElementById('cdjTable_3Tr_10Td').style.backgroundColor = "#BFBFBF"
        document.getElementById('cdjTable_3Tr_10Td').style.color = "#3E3C45"

        document.getElementById('cdjTable_1Tr_4Th').style.backgroundColor = "#F2F2F2"
        document.getElementById('cdjTable_1Tr_4Th').style.color = "#3E3C45"

        document.getElementById(tdId).style.backgroundColor = "#1817E7"
        document.getElementById(tdId).style.color = "#F2F2F2"
      }

      var startDate = moment(this.form.monthSelect[0]).format("YYYY-MM")
      var endDate = moment(this.form.monthSelect[1]).add(1, 'month').format("YYYY-MM")

      var firstClassList = []

      for(const item of this.selectedFirstClasses) {
        firstClassList.push(item)
      }

      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      var brandList = []

      if(this.selectedBrand != '' && this.selectedBrand != null ){        
        brandList.push(this.selectedBrand)
      }

      this.gubun = gubun
      this.etcList = etcList
      this.upperGubun = upperGubun
      this.etc = true

      // 중단 상위키워드 50
      // upperGubun이 '기타'일때
      var response = null
      if(this.upperGubun == '기타'){
        upperGubun = [this.attribute_search_detail_1_nm, this.attribute_search_detail_2_nm, this.attribute_search_detail_3_nm, this.attribute_search_detail_4_nm, '구매 후 관리', '추천/순위/종류', '비교/후기', '단순 카테고리 탐색', '가격 및 구매처 탐색']
        response = await CisInsightService.getInsightDataBottomTableETCETC({
          startDate : startDate,
          endDate : endDate,
          ctgSq : this.$store.getters.getSelectedCategory,
          brandList : brandList,
          firstClassList : firstClassList,
          selMiddle: sel_Middle, 
          gubun : gubun,
          etcList : etcList,
          upperGubun : upperGubun
        }, source);
      }else{// upperGubun이 '기타'가 아닐때
        response = await CisInsightService.getInsightDataBottomTableETC({
          startDate : startDate,
          endDate : endDate,
          ctgSq : this.$store.getters.getSelectedCategory,
          brandList : brandList,
          firstClassList : firstClassList,
          selMiddle: sel_Middle, 
          gubun : gubun,
          etcList : etcList,
          upperGubun : upperGubun
        }, source);
      }
      
      // const response = await CisInsightService.getInsightDataBottomTableETC({
      //   startDate : startDate,
      //   endDate : endDate,
      //   ctgSq : this.$store.getters.getSelectedCategory,
      //   brandList : brandList,
      //   firstClassList : firstClassList,
      //   selMiddle: sel_Middle, 
      //   gubun : gubun,
      //   etcList : etcList,
      //   upperGubun : upperGubun
      // }, source);

      if (response && response.status === 200) {
        console.log(response)

        this.fetchGroups2 = null
        this.fetchGroups2 = response.data.data
      }

      // 하단 mapHistory
      if(upperGubun == '속성 탐색'){
        this.mapHistory = '속성 탐색 > 기타'
      }else if(['단순 카테고리 탐색','추천/순위/종류','비교/후기'].includes(upperGubun)){
        this.mapHistory = '카테고리 탐색 > ' + upperGubun + ' > 기타'
      }else if(['등급', '신체부위/증상', '단점/부작용', '인물/광고', '기간', '국가', '지역', '성별', '연령대', '대상', '기능', '색상', '디자인', '소재/원료', '맛', '형태', '용량/크기', '두께/무게', '공간/장소', '용도/목적', '생산/가공', '차량종류', '계약내용', '금리', '담보', '먹거리', '볼거리', '놀거리', '숙박', '교통수단', '시트/크림', '토핑', '생산국', '연식', '겉감', '충전재', '기장', '핏', '패턴/프린트', '넥라인', '디테일/부자재'].includes(upperGubun)){
        this.mapHistory = '속성 탐색 > ' + upperGubun + ' > 기타'
      }else if(['구매 후 관리','가격 및 구매처 탐색'].includes(upperGubun)){
        this.mapHistory = '구매 및 관리 > ' + upperGubun + ' > 기타'
      }else{
        this.mapHistory = '속성 탐색 > 기타 > 기타'
      }

      // 하단 브랜드맵
      var brandMapresponse = null
      if(this.upperGubun == '기타'){
        upperGubun = [this.attribute_search_detail_1_nm, this.attribute_search_detail_2_nm, this.attribute_search_detail_3_nm, this.attribute_search_detail_4_nm, '구매 후 관리', '추천/순위/종류', '비교/후기', '단순 카테고리 탐색', '가격 및 구매처 탐색']
        brandMapresponse = await CisInsightService.getInsightDataBrandMapETCETC({
          startDate : startDate,
          endDate : endDate,
          ctgSq : this.$store.getters.getSelectedCategory,
          brandList : brandList,
          firstClassList : firstClassList,
          selMiddle: sel_Middle,    
          gubun : gubun,
          etcList : etcList,
          upperGubun : upperGubun
        }, source);
      }else{
        brandMapresponse = await CisInsightService.getInsightDataBrandMapETC({
          startDate : startDate,
          endDate : endDate,
          ctgSq : this.$store.getters.getSelectedCategory,
          brandList : brandList,
          firstClassList : firstClassList,
          selMiddle: sel_Middle,    
          gubun : gubun,
          etcList : etcList,
          upperGubun : upperGubun
        }, source);
      }

      // const brandMapresponse = await CisInsightService.getInsightDataBrandMapETC({
      //   startDate : startDate,
      //   endDate : endDate,
      //   ctgSq : this.$store.getters.getSelectedCategory,
      //   brandList : brandList,
      //   firstClassList : firstClassList,
      //   selMiddle: sel_Middle,    
      //   gubun : gubun,
      //   etcList : etcList,
      //   upperGubun : upperGubun
      // }, source);

      if (brandMapresponse && brandMapresponse.status === 200) {
        console.log('-- 하단 브랜드맵 data --')
        console.log(brandMapresponse)

        this.treeChartData1 = brandMapresponse.data.data
      }

      // 하단 라인 차트
      this.loadInsightDataLine()
    },    

    insightChartLineSeries(cd) {
        const chartSeries = [];
        for (const item of cd) {
          chartSeries.push({
            name: item.name,
            type: item.type,
            data: item.data,
            hidden: item.hidden
          })
        }
        return chartSeries;
    },

    getToday() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

      return year + month + day
    },

    exportToPDF: _.debounce(async function() {
      this.isPdfExporting = true;

      await sleep(1);

      var ret = await ExportPDF.exportToPDF([this.$refs.istPrintArea1, this.$refs.istPrintArea2, this.$refs.istPrintArea3], 'a4', 'l', 'insight_' + this.getToday() + '.pdf');

      if (ret) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "PDF export complete!!",
            icon: "EditIcon",
            variant: "success",
          },
        });
      }
      else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "PDF export fail!!",
            icon: "AlertCircleIcon",
            variant: "warning",
          },
        });
      }

      this.isPdfExporting = false;
    }, 100),

    newSheet4Intro(dataOrigin, category, major, period, serviceName) {
      var tmp_sheet = []

      tmp_sheet.push([]);
      tmp_sheet.push(['', { v: 'CONSUMER in SEARCH Ai', t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { t: "s", v: "consumerinsearch.com", l: {Target: "https://consumerinsearch.com"}, s: underlineStyle}]);
      tmp_sheet.push([]);
      tmp_sheet.push(['', { v: '데이터 개요', t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '대분류: ', t: "s", s: boldStyle }, { v: major, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '서비스명: ', t: "s", s: boldStyle }, { v: serviceName, t: "s", s: boldStyle }]);

      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    newSheet4CDJ(dataOrigin, category, major, period, columns) {
      var tmp_sheet = [];

      // Information
      tmp_sheet.push([{ v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '대분류: ', t: "s", s: boldStyle }, { v: major, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push([]);

      // Header
      var header_list = ['No.', '키워드'].concat(columns)
      var tmp_header = [];

      for (const col_nm of header_list) {
        tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
      };

      tmp_sheet.push(tmp_header);

      // Data
      tmp_sheet.push([{ v: 1, t: "n", s: indexNumStyle }, 
                      { v: '카테고리 탐색', t: "s", s: stringStyle }, 
                      { v: Math.round(this.general_search_freq_upper), t: "n", s: intNumStyle },
                      { v: 1, t: "n", s: rateNumStyle }
                    ]);
      tmp_sheet.push([{ v: 2, t: "n", s: indexNumStyle }, 
                      { v: '속성 탐색', t: "s", s: stringStyle }, 
                      { v: Math.round(this.attribute_search_freq_upper), t: "n", s: intNumStyle },
                      { v: 1, t: "n", s: rateNumStyle }
                    ]);
      tmp_sheet.push([{ v: 3, t: "n", s: indexNumStyle }, 
                      { v: '구매 및 관리', t: "s", s: stringStyle }, 
                      { v: Math.round(this.buy_manage_freq_upper), t: "n", s: intNumStyle },
                      { v: 1, t: "n", s: rateNumStyle }
                    ]);
      tmp_sheet.push([])
      tmp_sheet.push(['',
                      { v: 'Total', t: "s", s: stringStyle }, 
                      { v: Math.round(this.total_search_freq_upper), t: "n", s: intNumStyle },
                      { v: 1, t: "n", s: rateNumStyle }
                    ]);
      
      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    newSheet4BrandShare(dataOrigin, category, major, period, cdj, columns, data) {
      var tmp_sheet = [];

      // Information
      tmp_sheet.push([{ v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '대분류: ', t: "s", s: boldStyle }, { v: major, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '소비자 의사결정 여정: ', t: "s", s: boldStyle }, { v: cdj, t: "s", s: boldStyle }]);
      tmp_sheet.push([]);

      // Header
      var header_list = ['No.', '키워드'].concat(columns)
      var tmp_header = [];

      for (const col_nm of header_list) {
        tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
      };

      tmp_sheet.push(tmp_header);

      // Data
      var totalFreq = 0;
      var totalRate = 0;

      for (const idx in data) {         
        var tmp_row = [];

        tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle});             // No.
        tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle});             // 키워드
        tmp_row.push({t: "n", v: Number(data[idx].freq), s: intNumStyle});        // 검색량
        tmp_row.push({t: "n", v: Number(data[idx].rate) / 100, s: rateNumStyle}); // 비율        

        tmp_sheet.push(tmp_row)

        totalFreq += data[idx].freq;
        totalRate += data[idx].rate;
      }

      tmp_sheet.push([]);
      tmp_sheet.push(['', 
                      {t: "s", v: 'Total', s: stringStyle}, 
                      {t: "n", v: Number(totalFreq), s: intNumStyle}, 
                      {t: "n", v: Number(totalRate) / 100, s: rateNumStyle}
                     ]);
      
      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    newSheet4TopRankKeywords(dataOrigin, category, major, period, cdj, columns, data) {
      var tmp_sheet = [];

      // Information
      tmp_sheet.push([{ v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '대분류: ', t: "s", s: boldStyle }, { v: major, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '소비자 의사결정 여정: ', t: "s", s: boldStyle }, { v: cdj, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '*검색량 상위 키워드는 최대 500개까지 제공됩니다.', t: "s", s: boldStyle }]);
      tmp_sheet.push([]);

      // Header
      var header_list = ['No.', '키워드'].concat(columns)
      var tmp_header = [];

      for (const col_nm of header_list) {
        tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
      };

      tmp_sheet.push(tmp_header);

      // Data
      for (const idx in data) {         
        var tmp_row = [];

        tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle});                           // No.
        tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle});                           // 키워드
        tmp_row.push({t: "n", v: Number(data[idx].freq.replaceAll(',', '')), s: intNumStyle});  // 검색량
        tmp_row.push({t: "s", v: data[idx].brand, s: stringStyle});                             // 브랜드 

        tmp_sheet.push(tmp_row)
      }
      
      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    autoFit(data) {
      const wsCols = [];

      data.map((item) => {
        Object.keys(item).map((key, index) => {
          let text = item[key];
          let maxWidth;

          switch(typeof text) {
            case 'number':
              if (wsCols[index]) {
                if (text)
                  maxWidth = wsCols[index].width > 10 ? wsCols[index].width : 10;
                else
                  maxWidth = 10;
              }
              else
                maxWidth = text !== null ? 10 : 0;
                         
              break;
            case 'object':
              if (wsCols[index]) {
                if (text && text['v']) {
                  if (typeof text['v'] === 'number')
                    maxWidth = wsCols[index].width > 10 ? wsCols[index].width : 10;
                  else
                    maxWidth = wsCols[index].width < text['v'].length * 1.5 ? text['v'].length * 1.5 : wsCols[index].width;
                }
                else
                  maxWidth = wsCols[index].width;
              }
              else {
                if (text && text['v']) {
                  if (typeof text['v'] === 'number')
                    maxWidth = text['v'] !== null ? 10 : 0;
                  else
                    maxWidth = text['v'] !== null ? text['v'].length * 1.5 : 0;
                }
                else
                    maxWidth = 0;
              }

              break;
            case 'string':
              if (wsCols[index]) {
                if (text)
                  maxWidth = wsCols[index].width < text.length * 1.5 ? text.length * 1.5 : wsCols[index].width;
                else 
                  maxWidth = wsCols[index].width;
              }
              else 
                maxWidth = text !== null ? text.length * 1.5 : 0;
               
              break;
          }

          wsCols[index] = {width : maxWidth}
        })
      })

      for (var index in wsCols)
        wsCols[index].width = wsCols[index].width === 0 ? 10 : wsCols[index].width * 1.5;

      return wsCols
    },

    exportToExcel: _.debounce(async function() {
      const XLSX = require("xlsx-js-style");

      this.isXlsExporting = true;

      await sleep(1);

      try {
        
        var st_dt_str = moment(this.form.monthSelect[0]).format("YYYY-MM")
        var en_dt_str = moment(this.form.monthSelect[1]).add(1, 'month').format("YYYY-MM")

        const dataOrigin = 'NAVER';
        var category = 'Unknown';

        const catServResp = await CategoryService.getOneCategory(this.$store.getters.getSelectedCategory, source);

        if (catServResp.data.success)
          category = catServResp.data.data.title

        const period = moment(this.form.monthSelect[0]).format("YYYY-MM") + ' ~ ' + moment(this.form.monthSelect[1]).format("YYYY-MM");
      
        var majorStr = '전체';
        var firstClassList = []

        if (this.selectedFirstClasses.length > 0) {
          var major = [];

          for (const item of this.selectedFirstClasses) {
            major.push(item.title);
            firstClassList.push(item)
          }

          majorStr = major.join(', ');
        }

        const workbook = XLSX.utils.book_new()	// 엑셀 생성

        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4Intro(dataOrigin, category, majorStr, period, 'INSIGHT'), 
                                     '데이터 개요')
        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4CDJ(dataOrigin, category, majorStr, period, ['검색량', '비율']), 
                                     '소비자 탐색 오버뷰')
        
        var cdj_list = ['total', '카테고리 탐색', '속성 탐색', '구매 및 관리']

        for (const cdj of cdj_list) {
          const response = await CisInsightService.getInsightDataDonutBar({
            startDate : st_dt_str,
            endDate : en_dt_str,
            ctgSq : this.$store.getters.getSelectedCategory,
            brandList : this.selectedBrandList,
            firstClassList : firstClassList,        
            cdj : cdj
          }, source);

          if (response && response.status === 200) {
            const totalFreq = response.data.data.donutData[0].totalFreq
            var brandShareData = [];

            for(const item of response.data.data.barData) {
              brandShareData.push({
                keyword: item.brand,
                freq: item.freq,
                rate: item.freq / totalFreq * 100
              });
            }

            let cdj_str = cdj == 'total' ? 'Total' : cdj;

            XLSX.utils.book_append_sheet(workbook, 
                                         this.newSheet4BrandShare(dataOrigin, category, majorStr, period, cdj_str, ['검색량', '비율'], brandShareData), 
                                         '브랜드 점유율_' + cdj_str)
          }
        }

        const response = await CisInsightService.getInsightDataUpperTableExp({
          startDate : st_dt_str,
          endDate : en_dt_str,
          ctgSq : this.$store.getters.getSelectedCategory,
          brandList : this.selectedBrandList,
          firstClassList : firstClassList,        
          cdj : 'total'
        }, source);

        if (response && response.status === 200) {
          var topRankKeywords = [];

          for(const item of response.data.data) {
            topRankKeywords.push({
              keyword: item.keyword,
              freq: item.frequency.trim(),
              brand: item.brand
            });
          }

          XLSX.utils.book_append_sheet(workbook, 
                                       this.newSheet4TopRankKeywords(dataOrigin, category, majorStr, period, 'Total', ['검색량', '브랜드'], topRankKeywords), 
                                       '검색량 상위 키워드')
        }

        XLSX.writeFile(workbook, 'insight_' + this.getToday() + '.xlsx')	// 엑셀 다운로드

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Excel export complete!!",
            icon: "EditIcon",
            variant: "success",
          },
        });
      }
      catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Excel export fail!!",
            icon: "AlertCircleIcon",
            variant: "warning",
          },
        });
      }

      this.isXlsExporting = false;
    }, 100),

    removeSelItem(target, sel_idx) {
      target.splice(sel_idx, 1)
      target = [...target]
    },

    abort(isReset, message) {
      // cancel the request
      source.cancel(message);

      if (isReset)
        source = cancelToken.source();
    },

    selectAllCond() {
      if (this.isSelectAll_cond)
        this.selectedFirstClasses = []
      else {
        var temp_list = []
        
        for (const item of this.firstClassList)
          temp_list.push(item.id)

        this.selectedFirstClasses = temp_list
      }
    },

    majorChange() {
      console.log('---------- major change ----------')

      if (this.selectedFirstClasses != null && this.selectedFirstClasses.length > 0) {
        this.setMiddleClasses();
      }
      else {
        this.middleClassList = [];
        this.selectedMiddleClass = null;
      }
    },

    middleChange() {
      console.log('---------- middle change ----------')
    },

    async runAnalysis() {
      if(this.$store.getters.getSelectedCategory != '9999') {
        this.selectedBrand = "";
        this.selectedCDJ = "total";

        this.loadInsightDataCDJTableUpper();
        this.loadInsightDataCDJTableBottom();
        this.loadInsightDataDonutBar();
        this.loadInsightDataUpperTable();
        this.loadInsightDataBottomTable('total', '', '');
        this.setBrandList();
      }
    }
  },

  mounted(){
    console.log('----- mounted -----')

    console.log(this.userData)

    setTimeout(() => {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, 200);

    if(this.$store.getters.getSelectedCategory != '9999') {
      this.selectedBrand = "";
      this.selectedCDJ = "total";

      this.loadInsightDataCDJTableUpper();
      this.loadInsightDataCDJTableBottom();
      this.loadInsightDataDonutBar();
      this.loadInsightDataUpperTable();
      this.loadInsightDataBottomTable('total', '', '');
      this.setBrandList();
      this.setFirstClasses();
    }    
  },

  destroyed() {
    console.log('----- destroyed -----')
    
    this.abort(false, 'destoryed')
  },

  created() {
    console.log('----- create -----')

    this.abort(true, 'created')

    this.$store.dispatch('callCISMenu', { cisMenu: 'insight' })

    var st_dt = this.$store.getters.getSelectedPeriodSt
    var en_dt = this.$store.getters.getSelectedPeriodEn

    if (st_dt.length == 0 || en_dt.length == 0) {
      en_dt = moment().add(-2, 'days').toDate() // 데이터 업데이트 시점을 고려
      st_dt = new Date(en_dt)

      st_dt.setMonth(en_dt.getMonth() - 11)
    }

    this.form.monthSelect = [st_dt, en_dt]

    var st_dt_str = moment(st_dt).format("YYYY-MM")
    var en_dt_str = moment(en_dt).format("YYYY-MM")

    this.selectedDates.push(st_dt_str)
    this.selectedDates.push(en_dt_str) 

    this.selectedBrandList = [];
    this.selectedFirstClasses = [];
    this.selectedMiddleClass = null;
  },
};

</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

// table css /////////////////////////////////////////
.cdjTable
{
  width: 100.3%;
  border: 2px solid;
  border-color: #989898;
  text-align: center;
  color: #3E3C45;
}

.cdjTable th, 
.cdjTable td
{
  border: 1px solid;
  border-color: #989898;
  padding: 0.5rem 0.5rem;
}

.cdjTable td
{
  width: 9%;
}

.cdjTable_1Tr_1Th,
.cdjTable_2Tr_1Td,
.cdjTable_2Tr_2Td,
.cdjTable_2Tr_3Td,
.cdjTable_3Tr_1Td,
.cdjTable_3Tr_2Td,
.cdjTable_3Tr_3Td
{
  background-color: #F2F2F2;
  cursor: pointer;
}

.cdjTable_2Tr_1Td,
.cdjTable_2Tr_2Td,
.cdjTable_2Tr_3Td,
.cdjTable_3Tr_1Td,
.cdjTable_3Tr_2Td,
.cdjTable_3Tr_3Td
{
  font-size: 10px;
  font-weight: 600;
}

.cdjTable_1Tr_2Th,
.cdjTable_2Tr_4Td,
.cdjTable_2Tr_5Td,
.cdjTable_2Tr_6Td,
.cdjTable_2Tr_7Td,
.cdjTable_2Tr_8Td,
.cdjTable_3Tr_4Td,
.cdjTable_3Tr_5Td,
.cdjTable_3Tr_6Td,
.cdjTable_3Tr_7Td,
.cdjTable_3Tr_8Td
{
  background-color: #F2F2F2;
  cursor: pointer;
}

.cdjTable_2Tr_4Td,
.cdjTable_2Tr_5Td,
.cdjTable_2Tr_6Td,
.cdjTable_2Tr_7Td,
.cdjTable_2Tr_8Td,
.cdjTable_3Tr_4Td,
.cdjTable_3Tr_5Td,
.cdjTable_3Tr_6Td,
.cdjTable_3Tr_7Td,
.cdjTable_3Tr_8Td
{
  font-size: 10px;
  font-weight: 600;
}

.cdjTable_1Tr_3Th,
.cdjTable_2Tr_9Td,
.cdjTable_2Tr_10Td,
.cdjTable_3Tr_9Td,
.cdjTable_3Tr_10Td
{
  background-color: #F2F2F2;
  cursor: pointer;
}

.cdjTable_2Tr_9Td,
.cdjTable_2Tr_10Td,
.cdjTable_3Tr_9Td,
.cdjTable_3Tr_10Td
{
  font-size: 10px;
  font-weight: 700;
}

.cdjTable_1Tr_4Th,
.cdjTable_3Tr_11Td
{
  background-color: #F2F2F2;
  cursor: pointer;
}

//////////////////////////////////////////////////////


.select-brand .vs__dropdown-menu,
.first-class .vs__dropdown-menu,
.middle-class .vs__dropdown-menu
{
  padding: 0px 0px 0px 0px;
}

.select-brand .vs__dropdown-toggle, 
.middle-class .vs__dropdown-toggle 
{
  border: 2px solid #d8d6de;
}

.middle-class .vs__search,
.middle-class .vs__selected 
{
  height: 20px;
  margin-top: 4px !important;
}

.first-cls .v-input {
  flex: 0 0 auto;
}

.first-class .v-input__slot {
  width: 250px;
}

.first-cls .v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}

.first-cls .v-text-field--outlined fieldset {
  border: 2px solid #d8d6de;
} 

.first-cls .v-text-field--outlined fieldset legend {
  width: 0px !important;
} 

.first-cls .v-text-field--outlined {
  border-radius: 4px;
}

.first-cls .v-text-field--outlined .v-label {
  top: 6px;
}

.first-cls .v-text-field--enclosed .v-input__append-inner {
  margin-top: 6px;
}

.first-cls .v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px;
}

.first-cls .v-select.v-text-field--outlined:not(.v-text-field--single-line) .v-select__selections {
  padding: 0px;
}

.first-cls .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
  padding: 0 6px 0 12px;
}

.first-cls .v-select__slot {
  margin-left: 4px;
}

.first-cls .v-icon.v-icon {
  font-size: 19px;
}

.first-cls .v-text-field .v-label--active {
  display: none;
}

.first-class .v-label {
  font-size: 12px;
  font-weight: 600;
}

.istselectitemlist .v-list-item {
  min-height: 28px;
}

.istselectitemlist .v-list-item__content {
  padding: 3px 0;
}

.istselectitemlist .v-list-item__action {
  margin: 3px 0;
}

.istselectitemlist .v-list-item__action:first-child {
  margin-right: 15px;
}

.istselectitemlist .v-list-item__title {
  font-size: 12px;
  font-weight: 600;
}

.flat-picker {
  width: 263px;
}

#insightDonutCol .apexcharts-canvas .apexcharts-text, #insightDonutCol .apexcharts-canvas .apexcharts-tooltip-text, #insightDonutCol .apexcharts-canvas .apexcharts-datalabel-label, #insightDonutCol .apexcharts-canvas .apexcharts-datalabel 
, #insightBarCol .apexcharts-canvas .apexcharts-text, #insightBarCol .apexcharts-canvas .apexcharts-tooltip-text, #insightBarCol .apexcharts-canvas .apexcharts-datalabel-label, #insightBarCol .apexcharts-canvas .apexcharts-datalabel
{
    font-family: "NanumBarunGothic", Arial, sans-serif !important;
    font-weight: bold;
    filter: none;
}
#insightCDJCol .apexcharts-canvas .apexcharts-text, #insightCDJCol .apexcharts-canvas .apexcharts-tooltip-text, #insightCDJCol .apexcharts-canvas .apexcharts-datalabel-label, #insightCDJCol .apexcharts-canvas .apexcharts-datalabel
, #insightTreeCol .apexcharts-canvas .apexcharts-text, #insightTreeCol .apexcharts-canvas .apexcharts-tooltip-text, #insightTreeCol .apexcharts-canvas .apexcharts-datalabel-label, #insightTreeCol .apexcharts-canvas .apexcharts-datalabel 
{
  font-family: "NanumBarunGothic", Arial, sans-serif !important;
  // font-weight: bold;
  filter: none;
}

#insightBarCol .graphic-container {
  min-height: 450px;
  max-height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
}

// .graphic-container2 {
//   min-height: 450px;
//   max-height: 450px;
//   // overflow-y: auto;
//   // overflow-x: hidden;
// }

.row-background {
  height: 6%;
}

.row-background-title {
  height: 4%;
}

.tab_button1 {
  text-align: center; 
  width:33%;
  height:100%;
  // background-color: transparent !important; 
  background-color: #F2F2F2 !important; 
  border-color: transparent !important; 
  color: #3E3C45 !important;
  // background: url('../../assets/images/etc/insight_topbar_button1.png');
  // background-repeat: no-repeat !important;
  // background-size: cover !important;
  // background-position: center;
  // margin-top: -0.2%;
  // margin-bottom: -0.2%;
  margin-left: 0.1%;
  margin-right: 0.4%;
  font-size: 1.0rem;
  padding: 0.25rem 0.5rem;
  // clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
  // background-attachment: fixed;
}
.tab_button1:hover{
  // color: #1F1E22 !important;
  background-color: #F2F2F2 !important; 
  border-width: 2px;
  border-color: #1951DC !important; 
  font-size: 1.1rem;
}
.tab_button1:focus{
  // background-color: #1817E7 !important; 
  background-color: #F2F2F2 !important; 
  // border-color: #1817E7 !important; 
  // color: #F2F2F2 !important;
  font-size: 1.1rem;
  box-shadow: 0 0 0 1px #1817E7, 0 0 0 3px #1951DC;
}

.tab_button2 {
  text-align: center; 
  width:33%;
  height:100%;
  // background-color: transparent !important; 
  background-color: #F2F2F2 !important; 
  border-color: transparent !important; 
  color: #3E3C45 !important;
  // background: url('../../assets/images/etc/insight_topbar_button2.png');
  // background-repeat: no-repeat !important;
  // background-size: cover !important;
  // background-position: center;
  // margin-top: -0.2%;
  // margin-bottom: -0.2%;
  margin-right: 0.4%;
  font-size: 1.0rem;
  padding: 0.25rem 0.5rem;
  // clip-path: polygon(90% 0%, 100% 50%, 90% 100%, 0% 100%, 10% 50%, 0% 0%);
  // background-attachment: fixed;
}
.tab_button2:hover{
  // color: #1F1E22 !important;
  background-color: #F2F2F2 !important; 
  border-width: 2px;
  border-color: #1951DC !important; 
  font-size: 1.1rem;
}
.tab_button2:focus{
  background-color: #F2F2F2 !important; 
  // color: #F2F2F2 !important;
  font-size: 1.1rem;
  box-shadow: 0 0 0 1px #1817E7, 0 0 0 3px #1951DC;
}
.tab_button3 {
  text-align: center; 
  width:33%;
  height:100%;
  // background-color: transparent !important; 
  background-color: #F2F2F2 !important; 
  border-color: transparent !important; 
  color: #3E3C45 !important;
  // background: url('../../assets/images/etc/insight_topbar_button3.png');
  // background-repeat: no-repeat !important;
  // background-size: cover !important;
  // background-position: center;
  // margin-top: -0.2%;
  // margin-bottom: -0.2%;
  margin-right: 0.1%;
  font-size: 1.0rem;
  padding: 0.25rem 0.5rem;
  // clip-path: polygon(88% 0%, 98% 50%, 88% 100%, 0% 100%, 10% 50%, 0% 0%);
  // background-attachment: fixed;
}
.tab_button3:hover{
  // color: #1F1E22 !important;
  background-color: #F2F2F2 !important; 
  border-width: 2px;
  border-color: #1951DC !important; 
  font-size: 1.1rem;
}
.tab_button3:focus{
  background-color: #F2F2F2 !important; 
  // color: #F2F2F2 !important;
  font-size: 1.1rem;
  box-shadow: 0 0 0 1px #1817E7, 0 0 0 3px #1951DC;
}
.tab_button4 {
  text-align: center; 
  width:100%;  
  height:100%;
  // background-color: transparent !important; 
  background-color: #F2F2F2 !important; 
  border-color: transparent !important; 
  color: #3E3C45 !important;
  // background: url('../../assets/images/etc/insight_topbar_button4.png');
  // background-repeat: no-repeat !important;
  // background-size: cover !important;
  // background-position: center;
  // clip-path: polygon(100% 0%, 100% 50%, 100% 100%, 0% 100%, 0% 50%, 0% 0%);
  // margin-top: -0.2%;
  // margin-bottom: -0.2%;
  margin-left: 0.1%;
  margin-right: 0.1%;
  font-size: 1.1rem;
  padding: 0.25rem 0.5rem;
}
.tab_button4:hover{
  // color: #1F1E22 !important;
  background-color: #F2F2F2 !important; 
  border-width: 2px;
  border-color: #1951DC !important; 
  font-size: 1.2rem;
}
.tab_button4:focus{
  background-color: #F2F2F2 !important; 
  // color: #F2F2F2 !important;
  font-size: 1.2rem;
  box-shadow: 0 0 0 1px #1817E7, 0 0 0 3px #1951DC;
}

.mb-1 .sticky-top{
  align-self: flex-start;
}

.horizontal-line {
    border-top: 1px solid black; /* 수평선 스타일 정의 */
    margin-top: 0.3%; /* 필요에 따라 여백 설정 */
    margin-bottom: 0.3%; /* 필요에 따라 여백 설정 */
}

/* Hide default icon */
.table1 .table.b-table > thead > tr > th,
.table1 .table.b-table > tfoot > tr > td,
.table2 .table.b-table > thead > tr > th,
.table2 .table.b-table > tfoot > tr > td {
  background-image: none !important;
  vertical-align: middle !important;
  padding: 0.75rem 0.5rem;
}

.table1 .table-font-size, 
.table2 .table-font-size {
  font-size: 12px;
  font-weight: 600;
}

.table1 .b-table thead th.w20{
  width: 20%;
}

.insselectallcond {
  margin: 0px !important;
  padding: 0px !important;
}

.insselectallcond .v-input__slot {
  padding: 0 16px;
}

.insdivider {
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
}

</style>
